import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import "./orderWizard.css";
import WebViewer from "@pdftron/webviewer";
import {
    // listMeida,
    portraitList,
    landscapeList,
    customeSize,
    description,
    errorMessages
} from "./variable";
import API, {uploadFile, uploadFileProduct/*, uploadFileFile, uploadImageTiffComp */ } from './api/api'; 
import axios from "axios";
import { decode } from 'decode-tiff';
import {Buffer} from 'buffer';
import ProgressBar from './loading/ProgressBar';
import fileDownload from "js-file-download";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { getDocument } from "pdfjs-dist";
import { GlobalWorkerOptions } from "pdfjs-dist/build/pdf"; 
// GlobalWorkerOptions.workerSrc = `${siteUrl}/react/build/assets/js/pdf.worker.js`; //doesnt work becase $siteurl is not yet defined
// GlobalWorkerOptions.workerSrc = "https://x.posterprintshop.com/wp-content/plugins/ppsposter-react/react/build/assets/js/pdf.worker.js";
// GlobalWorkerOptions.workerSrc = "https://posterprintshop.com/wp-content/plugins/ppsposter-react/react/build/assets/js/pdf.worker.js";
GlobalWorkerOptions.workerSrc = "/wp-content/plugins/ppsposter-react/react/build/assets/js/pdf.worker.js";

// const landscapeImg = process.env.PUBLIC_URL + "/landscape-icon.svg";
// const portraitImg = process.env.PUBLIC_URL + "/portrait-icon.svg";
const upload = process.env.PUBLIC_URL + "/upload.svg";
const info_icon = process.env.PUBLIC_URL + "/info_icon.svg";
// const dlIcon = process.env.PUBLIC_URL + "/downloadIcon.svg";

function App() {
    const [siteUrl, setSiteUrl] = useState(window.appVars ? window.appVars.siteUrl : window.location.origin);
    // const [pluginPath, setPluginPath] = useState(window.appVars ? window.appVars.pluginPath : '/home/posterliveadmin/public_html/wp-content/plugins/ppsposter-react/');
    // const [webrootPath, setWebrootPath] = useState(window.appVars ? window.appVars.webrootPath : '/home/posterliveadmin/public_html/');
    const MULT_NUM = 72;

    const formEl = useRef();
    const formOrgSrc = useRef();
    const formFName = useRef();
    const updateShowPopup = useRef(null);
    const updateShowPopupChecker = useRef(null);
    const viewer = useRef(null);
    const [instance, setInstance] = useState();
    const [imgOrigHeight, setImgOrigHeight] = useState(0);
    const [imgOrigWidth, setImgOrigWidth] = useState(0);
    const [imgHeight, setImgHeight] = useState(0);
    const [imgWidth, setImgWidth] = useState(0);
    const [landscapePort, setLandscapePort] = useState(false); //false is landscape
    const [hasOrientationChanged, setHasOrientationChanged] = useState(false);
    const [fitFill, setFitFill] = useState(true);
    const [mobileLock, setMobileLock] = useState(true);
    const [printFitSize, setPrintFitSize] = useState(false);
    const [aspectLock, setAspectLock] = useState(false);
    const [docHeight, setDocHeight] = useState(18); //multiply by 96
    const [docWidth, setDocWidth] = useState(24);
    const [inputHeight, setInputHeight] = useState(24);
    const [inputWidth, setInputWidth] = useState(18);
    const [proportionalWidth, setProportionalWidth] = useState(18);
    const [proportionalHeight, setProportionalHeight] = useState(18);
    const [currFile, setCurrFile] = useState([]);
    // const [currFileData, setCurrFileData] = useState('');
    const [currImgData, setCurrImgData] = useState();
    const [hasImage, setHasImage] = useState(false);
    const [selectedSize, setSelectedSize] = useState("1");
    const [selectedMedia, setSelectedMedia] = useState("1");
    const [prevDocWidth, setPrevDocWidth] = useState(0);
    const [prevDocHeight, setPrevDocHeight] = useState(0);
    const [prevAnnotWidth, setPrevAnnotWidth] = useState(0);
    const [prevAnnotHeight, setPrevAnnotHeight] = useState(0);
    const [prevAnnotX, setPrevAnnotX] = useState(0);
    const [prevAnnotY, setPrevAnnotY] = useState(0);
    const [loadingTiff, setLoadingTiff] = useState(false);
    const fileInputRef = useRef(null);
    const [disableInput, setDisableInput] = useState(true);
    const [price, setPrice] = useState(20);
    const [basePrice, setBasePrice] = useState(6);
    const postionXY = useRef({ x: 0, y: 0 });
    const docSize = useRef({ width: 0, height: 0 });
    const [loading, setLoading] = useState(true);
    const [webLoading, setWebLoading] = useState(true);
    const [webviewerLoading, setWebviewerLoading] = useState(true);
    const [isFullLoading , setIsFullLoading] = useState(false);
    const [genPdf, setGenPdf] = useState(false);
    const [isSingle, setIsSingle] = useState(false);
    const [isServicesPage, setIsServicesPage] = useState(false);
    const [productName, setProductName] = useState('Quick Order Wizard');
    const [productUrl, setProductUrl] = useState('/order-wizard-s/');
    const [categoryName, setCategoryName] = useState('');
    const [categoryUrl, setCategoryUrl] = useState('');
    const [mediaList, setMediaList] = useState([]);
    const [mediaListFinal, setMediaListFinal] = useState([]);
    const urlImage = useRef();
    const [completed, setCompleted] = useState(0);
    const [initDoc, setInitDoc] = useState(`${siteUrl}/wp-content/uploads/webv/pexels-adil-26683141692723135.jpg`);
    const [fname, setFname] = useState('pexels-adil-26683141692723135_.jpg');
    //const [orgSrc, setOrgSrc] = useState(`${siteUrl}/wp-content/uploads/webv/thumbnail/pexels-adil-26683141692723135_thumb_.jpg`) //pdf URL
    const [orgSrc, setOrgSrc] = useState(`${siteUrl}/converted-image.jpg`) //pdf URL
    const [origName, setOrigName] = useState('pexels-adil-26683141692723135.jpg');
    const [origFName, setOrigFName] = useState('');
    const [fileNameNoExt, setFileNameNoExt] = useState('pexels-adil-26683141692723135');
    const [fileExt, setFileExt] = useState('jpg');
    const [fType, setFType] = useState('image/jpeg');    
    const [times, setTimes] = useState('');
    const [forExport, setForExport] = useState('');
    const [jsTime, setJsTime] = useState(Date.now());
    const [isTiff, setIsTiff] = useState(false);
    const [fileType, setFileType] = useState('jpg');
    const [proofType, setProofType] = useState('');
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [prodId, setProdId] = useState(218621);
    const [isPdf, setIsPdf] = useState(false);
    const [isMax, setIsMax] = useState(false);

    
    const [mediaName, setMediaName] = useState('Photo Gloss');
    const [mediaSlug, setMediaSlug] = useState('photo-gloss');
    const [mediaProdId, setMediaProdId] = useState(218621);
    const [mediaValue, setMediaValue] = useState(null);
    const [selectedWidth, setSelectedWidth] = useState(18);
    const [selectedHeight, setSelectedHeight] = useState(24);
    const [sizeValue, setSizeValue] = useState(null);
    const [mediaInfo, setMediaInfo] = useState([]);
    // const [currFileBlob, setCurrFileBlob] = useState([]);
    // const [currFileName, setCurrFileName] = useState("");

    const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorType, setErrorType] = useState("");




    const isDevelopment = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "local"; // Check if the environment is development or local php -S server
    // DynamicUploadPath = check if variable uploadPath is set in pps-order-wizard.php, if not set it to wp default
    const relativePath = window.appVars ? window.appVars.relativePath : '/wp-content/uploads/webvr/'; // Use wordpress localized variables from pps-order-wizard.php, else default
    const uploadPath = isDevelopment ? '/uploads/' : relativePath; //If is development use /uploads/ else use dynamicUploadPath above. 
    const thumbUploadPath = uploadPath + 'thumbnail/'; // ThumbUploadPath is whatever upload path is + 'thumbnail/'


    // Order Configure Page url - if not set in pps-order-wizard.php, use default
    const orderConfigureUrl = window.appVars ? window.appVars.orderConfigureUrl : '/order-configure/';
    const formUrl = isDevelopment ? process.env.REACT_APP_ORDERCONFIGUREURL : orderConfigureUrl; // For local, get it from environment variable. For Build and wordpress, get it from pps-order-wizard.php or default

    // const pluginPath = window.appVars ? window.appVars.pluginPath : '/wp-content/plugins/pps-order-wizard/';
    // const webrootPath = window.appVars ? window.appVars.webrootPath : process.env.REACT_APP_WEBROOTPATH ; // This is wordpress ABSPATH

    //Variables coming from .env files like .env.development (npm start), .env.local (php -S), .env.production (npm run build)  
    const webviewerPath = process.env.REACT_APP_WEBVIEWER_PATH;
    const innerCSSPath = process.env.REACT_APP_WEBVIEWER_CSS;
    const uploadUrl = process.env.REACT_APP_UPLOAD_URL;
    const initialDoc = process.env.REACT_APP_INITIALDOC_URL;
    const licenseKey = process.env.REACT_APP_LICENSEKEY;


    const [documentLoading, setDocumentLoading] = useState(false); // Spinner inside Webviewer
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploading, setUploading] = useState(false); // Image Upload Progress Bar
    // const [fileName, setFileName] = useState(""); // Used in finalFName in the form, but not used now. 
    // const [origFileName, setOrigFileName] = useState("");
    // const [origFileMimeType, setOrigFileMimeType] = useState("");
    // const [thumbFileName, setThumbFileName] = useState("");
    // const [fileDisplayName, setFileDisplayName] = useState("");
    // const [fileNameNoExtension, setFileNameNoExtension] = useState("");
    // const [data_o_img, setData_o_img] = useState(""); // The filename for the final image in jpg format with _ at the end, that cart code expects. Like jpgsmall-1733481769_.jpg (real image is .pdf, but cart code expects .jpg)
    // const [finalFileUrl, setFinalFileUrl] = useState(""); // The final file URL to be used in the cart
    // const [isLandscape, setIsLandscape] = useState(false); //false is Portrait, true is landscape
    // const [fileSize, setFileSize] = useState(0);
    // const [fileSizeInMb, setFileSizeInMb] = useState(0);

    
    // const [isProductPage, setIsProductPage] = useState(false); // Should default to false
    const [orderMethod, setOrderMethod] = useState("Wizard S");

    const [isExactMatch, setIsExactMatch] = useState(false); // Should default to false
    // const [isCropApplied, setIsCropApplied] = useState(false); // Should default to false 
    // const [isDownloadingProof, setIsDownloadingProof] = useState(false); // Should default to false 

    // const [filePath, setFilePath] = useState(null);

    // const info_icon = process.env.REACT_APP_MEDIA_URL + "/info_icon.svg";
    const mediaUrl = process.env.REACT_APP_MEDIA_URL; // Media URL for images and icons, set in .env files


 // End currently not in use 



    const getUserValues = () => {
        console.log("----- Inside of getUserValues -----");
        let tempMediaInfo = null;
        // instance.UI.loadDocument(fileBlob, { filename: fileBlob.name }); // Load the file into WebViewer
        if (document.body.classList.contains('single-product')) {
            console.log('You are on a WooCommerce single product page.');
            ({ tempMediaInfo } = getProductSelectedValues());
        }else{
            console.log('You are NOT on a WooCommerce single product page.');
            ({ tempMediaInfo } = getSelectedValues());
        }

        // console.log("mediaInfo Before Setting: ", mediaInfo);
        setInputWidth(tempMediaInfo.selectedWidth);
        setInputHeight(tempMediaInfo.selectedHeight);
        setSelectedWidth(tempMediaInfo.selectedWidth);
        setSelectedHeight(tempMediaInfo.selectedHeight);

        //temp for styling purposes
        // setInputWidth(24);
        // setInputHeight(24);
        // setSelectedWidth(24);
        // setSelectedHeight(24);

        setProdId(tempMediaInfo.mediaProdId);
        setMediaSlug(tempMediaInfo.mediaSlug);
        setMediaValue(tempMediaInfo.mediaValue);
        setSizeValue(tempMediaInfo.sizeValue);
        setMediaName(tempMediaInfo.mediaName);
        setMediaInfo(tempMediaInfo);
        // console.log("tempMediaInfo: ", tempMediaInfo);
        // console.log("mediaInfo AFTER setting: ", mediaInfo);
        return tempMediaInfo;
    }
     // Get user selected values from the DOM
  const getSelectedValues = () => {
    console.log("----- Inside of getSelectedValues -----");
    let selectedMedia = document.querySelector("input[name='poster_media']:checked");
    let selectedSize = document.querySelector("input[name='poster_media_size']:checked");
   
    
    // console.log("selectedMedia: ", selectedMedia);
    // console.log("selectedSize: ", selectedSize);  
    if (!selectedMedia || !selectedSize) return { mediaInfo: null };
  
    let tempMediaInfo = {
      mediaProdId: selectedMedia.getAttribute("data-prodid"),
      mediaValue: selectedMedia.value, // The product slug  
      mediaName: selectedMedia.getAttribute("data-name"),
      mediaSlug: selectedMedia.getAttribute("data-name"),
      selectedWidth: selectedSize.getAttribute("data-width"),
      selectedHeight: selectedSize.getAttribute("data-height"),
      sizeValue: selectedSize.value,
    };

    // console.log("before custom width and height");
    if(selectedSize.value === '7') {
        tempMediaInfo.selectedWidth = document.getElementById("poster_media_size_custom_width").value;
        tempMediaInfo.selectedHeight = document.getElementById("poster_media_size_custom_height").value;
        console.log("custom width and height", tempMediaInfo.selectedWidth, tempMediaInfo.selectedHeight);
    }
    
    // This is temporary - later get the actual slug, Display Name etc from the DOM, coming from PHP
      let sanitizedName = selectedMedia.getAttribute("data-name");
      if (!sanitizedName) {
        console.error("data-name attribute is missing on selectedMedia element");
      } else {
        sanitizedName = sanitizedName.replace(/-/g, ' ');
        sanitizedName = sanitizedName.replace(/\b\w/g, char => char.toUpperCase());
        tempMediaInfo.mediaName = sanitizedName;
        // setMediaName(sanitizedName);
      }

  
    return { tempMediaInfo };
  };
  
   //Product page - Get selectedvalues
  const getProductSelectedValues = () => {
    console.log("----- Inside of getPRODUCTSelectedValues -----");

    let selectedWidth = document.getElementById("poster_media_size_custom_width")?.value || 0;
    let selectedHeight = document.getElementById("poster_media_size_custom_height")?.value || 0;
    let mediaTypeDropdown = document.getElementById("ppsowMediaType");

    if (!mediaTypeDropdown) {
      console.error("Media type dropdown not found");
      return { mediaInfo: null };
    }

    let selectedMediaOption = mediaTypeDropdown.options[mediaTypeDropdown.selectedIndex];
    if (!selectedMediaOption) {
      console.error("Selected media option not found");
      return { tempMediaInfo: null };
    }

    let price = selectedMediaOption.getAttribute("data-price") || 0;
    let prodId = selectedMediaOption.getAttribute("data-prodid") || 0;
    let selectedId = selectedMediaOption.id || "";
    let mediaName = selectedMediaOption.text.trim().replace(/[^a-zA-Z0-9\s]/g, '') || "";

    let tempMediaInfo = {
      mediaProdId: prodId,
      mediaValue: price, // The Media Price
      mediaName: mediaName, // The product slug
      mediaSlug: selectedId,
      selectedWidth: selectedWidth,
      selectedHeight: selectedHeight,
      // sizeValue: selectedSize.value,
    };

    // setMediaName(mediaName);

    //set Breadcrumb names and urls
    const path = window.location.pathname;
    if (path.includes("/services/")) {
        setIsServicesPage(true);
        setOrderMethod("Service Wizard S");
    }else{
        setOrderMethod("Product Wizard S");
    }
    const matches = path.split("/").filter(Boolean);
    console.log("path: ", path);
    console.log('Matches 0:, ',matches[0]);
    console.log('Matches 1:, ',matches[1]);

    let match1 = matches[0];
    let match2 = matches[1];
    let productName = '';
    let productUrl = '';

    let categoryName = match1 ? match1.replace(/-/g, ' ').split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") : ""; 
    let categoryUrl = match1 ? '/' + match1 + '/' : "";
    let categoryLinkElement = document.querySelector("#category-link a");
    if (categoryLinkElement) {
        categoryUrl = categoryLinkElement.pathname;
        categoryName = categoryLinkElement.innerHTML.replace(/-/g, ' ').split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
        console.log("#category-link a exists");
        console.log('Category Name: ', categoryName);
        console.log('Category URL: ', categoryUrl);
    }else{
        console.log("#category-link a DOES NOT exists");
    }

    productName = match2 ? match2.replace(/-/g, ' ').split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ") : "";
    productUrl = path ? path : window.location.href;
    console.log('Product Name: ', productName);
    console.log('Product URL: ', productUrl);
    console.log('Category Name: ', categoryName);
    console.log('Category URL: ', categoryUrl);


    setProductName(productName);
    setProductUrl(productUrl);
    setCategoryName(categoryName);
    setCategoryUrl(categoryUrl); 

    return { tempMediaInfo };
  };


    const uploadImageProduct = async (file, file_type='', timestmp='') => {
        console.log('uploadImage called');
        //let res = await API.uploadImageStep1(file);
        let res
        //console.log(res);

        try {
            res = await uploadFileProduct(file, file_type, timestmp, (event) => {
            //  const percentCompleted = Math.round((event.loaded * 100) / event.total);
            //  if(file_type !== 'pdf')
            //      setCompleted(percentCompleted);
           }); 
         } catch (error) {
           //console.log(error);
           //return;
         }

    };

    // const uploadImageFile = async (file, file_type='', timestmp='') => {
    //     console.log('uploadImage called');
    //     //let res = await API.uploadImageStep1(file);
    //     let res
    //     //console.log(res);

    //     try {
    //         res = await uploadFileFile(file, file_type, timestmp, (event) => {
    //         //  const percentCompleted = Math.round((event.loaded * 100) / event.total);
    //         //  if(file_type !== 'pdf')
    //         //      setCompleted(percentCompleted);
    //        }); 
    //      } catch (error) {
    //        //console.log(error);
    //        //return;
    //      }

    // };

    const uploadImage = async (file, file_type='', timestmp='') => {
        console.log('uploadImage called');
        //let res = await API.uploadImageStep1(file);
        let res
        //console.log(res);

        try {
            res = await uploadFile(file, file_type, timestmp, '', (event) => {
             const percentCompleted = Math.round((event.loaded * 100) / event.total);
             if(file_type !== 'pdf')
                 setCompleted(percentCompleted);

            if(file_type === 'tiff')
                setHasImage(true);
           }); 
         } catch (error) {
           console.log(error);
           return;
         }

           if (res.data.status === "success") {
            //setLoading(false);
            urlImage.current = res.data.url;
            let img_url = res.data.url;
            let orig_name = res.data.orig_name;
            setInitDoc(res.data.url);
            console.log('all data: ', res.data);
            console.log('image url: ', res.data.url);
            let img_parts = img_url.split('/');
            let img_name_only = img_parts[img_parts.length - 1];
            console.log('img_name_only: ', img_name_only);
            //setFname(img_name_only);
            
            let orig_name_parts = orig_name.split('.');
            console.log('file type -----> ', file_type);
            if(file_type !== 'pdf') {
                setLoading(false);
                setOrigName(orig_name);
                console.log('set orig name: ', orig_name);

                console.log('set file ext ----> ', orig_name_parts[orig_name_parts.length - 1]);
                console.log('set ftype: ', res.data.ftype);

                setFileExt(orig_name_parts[orig_name_parts.length - 1]);
                if(orig_name_parts[orig_name_parts.length - 1] === 'pdf')
                    setFType('application/pdf');
                else
                    setFType(res.data.ftype);

            } else {
                setFileExt('pdf');
                setFType('application/pdf');
            }
            let img_name_parts = img_name_only.split('.');
            let img_name = img_name_parts[0];
            console.log('img_name: ', img_name);
            setFileNameNoExt(orig_name_parts[0]);
            console.log('fileNameNoExt: ', orig_name_parts[0]);

            return [res.data.tiff_width, res.data.tiff_height];

            }else{
                let message = "uploadError: " + res.data.message;
                // errorPopup(res, message);
                showErrorModal(message, "uploadError");
            }
    };

    const generatePDF = async () => {

        setLoading(true);
        setGenPdf(true);

        const instance = window.WebViewer.getInstance();
        const annotationManager =
            instance.Core.documentViewer.getAnnotationManager();

        const annots = annotationManager
            .getAnnotationsList()
            .filter((annot) => annot.PageNumber === 1);
        annotationManager.selectAnnotations(annots);

        const currentlySelectedAnnotation =
            annotationManager.getSelectedAnnotations()[0];

        const docHeight = inputHeight * MULT_NUM;
        const docWidth = inputWidth * MULT_NUM;
        const imgHeight = currentlySelectedAnnotation.getHeight();
        const imgWidth = currentlySelectedAnnotation.getWidth();
        const imgX = currentlySelectedAnnotation.getX();
        const imgY = currentlySelectedAnnotation.getY();

        console.log('file ext: ', fileExt);
        
        let res = await API.generatePDF(
            urlImage.current,
            docHeight,
            docWidth,
            imgHeight,
            imgWidth,
            imgX,
            imgY,
            jsTime,
            fileExt
        );

        console.log('check res');
        console.log(res);
        // console.log(res.data);
        // console.log('get ext: ', res.data.get_ext);

        if (res.data.status === "success") {
            //setLoading(false);
            let url = res.data.url;
            // let filename = "proof.pdf";

            console.log('check url: ', res.data.url);

            setOrgSrc(url);
            formOrgSrc.current.value = res.data.url;
            console.log('time_s: ', res.data.time_s);
            setFname(res.data.fname);
            formFName.current.value = res.data.fname;

            console.log('fname: ', res.data.fname);
            console.log('org_src: ', orgSrc);
            console.log('p_w: ', inputWidth);
            console.log('p_h: ', inputHeight);
            console.log('orig_name: ', origName);
            console.log('image_origHeight: ', imgOrigHeight);
            console.log('image_origwidth: ', imgOrigWidth);
            console.log('file name no ext: ', fileNameNoExt);
            console.log('init doc: ', initDoc);

            formEl.current.submit();
        }else{
            let message = "processingError: " + res.data.message;
            // errorPopup(res, message);
            showErrorModal(message, "processingError");
        }
    }

    // const handleChangeWidth = (event) => {
    //     let media = mediaListFinal.find((item) => item.id === selectedMedia);
    //     setInputWidth(event.target.value);
    //     calulatePrice(basePrice, event.target.value, inputHeight);

    //     if(event.target.value > 60 && inputHeight > 60) {
    //         setIsMax(true);
    //     } else {
    //         setIsMax(false);
    //     }
    // };

    // const handleChangeHeight = (event) => {
    //     // let media = mediaListFinal.find((item) => item.id === selectedMedia);
    //     setInputHeight(event.target.value);
    //     calulatePrice(basePrice, inputWidth, event.target.value);

    //     if(event.target.value > 60 && inputWidth > 60) {
    //         setIsMax(true);
    //     } else {
    //         setIsMax(false);
    //     }        
    // };

    const togglePrintFitSize = async () => {
        setPrintFitSize(!printFitSize);

        const instance = window.WebViewer.getInstance();
        const doc = instance.Core.documentViewer.getDocument();
        let pageInfo = doc.getPageInfo(1);

        const { annotationManager } = instance.Core;
        const annots = annotationManager
            .getAnnotationsList()
            .filter((annot) => annot.PageNumber === 1);
        annotationManager.selectAnnotations(annots);
        const currentlySelectedAnnotation =
            annotationManager.getSelectedAnnotations()[0];

        const doc_temp = instance.Core.documentViewer.getDocument();
        let doc_t;
        let img;
        let newHeight = 0;
        let newWidth = 0;
        let useDataURL = false;    
        useDataURL = true;    

        let type = 'jpg';
        const queryParameters = new URLSearchParams(window.location.search);
        const from_single = queryParameters.get("from_single");
        setIsFullLoading(true);

        if(printFitSize) {
            setInputHeight(prevDocHeight);
            setInputWidth(prevDocWidth);
    
            setDocHeight(prevDocHeight);
            setDocWidth(prevDocWidth);

            newHeight = prevDocHeight;
            newWidth = prevDocWidth;
    
            await doc_temp.insertBlankPages(
                [1],
                newWidth * MULT_NUM,
                newHeight * MULT_NUM
            );
            await doc_temp.removePages([2]);
    
            if (currFile || from_single === 'yes') {
                await instance.Core.PDFNet.initialize();

                if(from_single === 'yes') {                   
                    let get_single_url = localStorage.getItem("poster-furl");
                    get_single_url = get_single_url.replace(siteUrl,"");
                    doc_t = await instance.Core.createDocument(get_single_url, { extension: type, loadAsPDF: true }); 

                } else {

                    img = document.createElement("img");
                    img.src = URL.createObjectURL(currFile);
        
                    img.onload = function (event) {
                        console.log(event);
                        console.log({ width: img.width, height: img.height });
                    };
        
                    img.src = URL.createObjectURL(currFile);

                    doc_t = await instance.Core.createDocument(currFile, { extension: fileType, loadAsPDF: true });    
                }
                
    
                const annotX = prevAnnotX;
                const annotY = prevAnnotY;
    
                // create the stamp annotation
                let annot = new instance.Core.Annotations.StampAnnotation({
                    PageNumber: 1,
                    X: annotX,
                    Y: annotY,
                    Width: prevAnnotWidth,
                    Height: prevAnnotHeight,
                    MaintainAspectRatio: true,
                });
                setPostionXY(annotX, annotY, pageInfo.width, pageInfo.height); // SetPostion to be upload in server
    
                // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
                doc_t.loadCanvas({
                    pageNumber: 1,
                    zoom: 2,
                    drawComplete: async (image) => {
                        let data = useDataURL ? image.toDataURL() : image.src;
                        annot.setImageData(data);
                        instance.Core.annotationManager.addAnnotation(annot);
                        instance.Core.annotationManager.redrawAnnotation(annot);        
                        setIsFullLoading(false);                
                    },
                });
    
                // add the annotation to the document and redraw it
                // instance.Core.annotationManager.addAnnotation(annot);
                // instance.Core.annotationManager.redrawAnnotation(annot);
            }
    
            instance.Core.documentViewer.removeEventListener();

        } else {
            let annotWidth = 0;
            let annotHeight = 0;
            let checkHeight =
                (imgOrigHeight / imgOrigWidth) * (docWidth * MULT_NUM);
            let checkWidth =
                (imgOrigWidth / imgOrigHeight) * (docHeight * MULT_NUM);

            if(inputHeight >= inputWidth) {
                let scale = imgOrigWidth / imgOrigHeight;
                annotWidth = checkWidth;
                annotHeight = (imgOrigHeight / imgOrigWidth) * (checkWidth);
        
                if(annotWidth > (docWidth*MULT_NUM)) {
                    annotWidth = (docWidth*MULT_NUM);
                    annotHeight = annotWidth / scale;
                }
        
            } else {
                let scale = imgOrigHeight / imgOrigWidth;
                annotHeight = checkHeight;
                annotWidth = (imgOrigWidth / imgOrigHeight) * (checkHeight);
        
                if(annotHeight > (docHeight*MULT_NUM)) {
                    annotHeight = (docHeight*MULT_NUM);
                    annotWidth = annotHeight / scale;
                }
        
            }
            
            //start setlandport copy ****

            setPrevDocWidth(inputWidth);
            setPrevDocHeight(inputHeight);
            setPrevAnnotWidth(currentlySelectedAnnotation.getWidth());
            setPrevAnnotHeight(currentlySelectedAnnotation.getHeight());
            setPrevAnnotX(currentlySelectedAnnotation.getX());
            setPrevAnnotY(currentlySelectedAnnotation.getY());

            setInputHeight(Math.round(annotHeight / 72));
            setInputWidth(Math.round(annotWidth / 72));
    
            setDocHeight(Math.round(annotHeight / 72));
            setDocWidth(Math.round(annotWidth / 72));
    
            newHeight = annotHeight;
            newWidth = annotWidth;
            

    
            await doc_temp.insertBlankPages(
                [1],
                newWidth,
                newHeight
            );
            await doc_temp.removePages([2]);
    
            if (currFile || from_single === 'yes') {
                await instance.Core.PDFNet.initialize();


                if(from_single === 'yes') {
                    let get_single_url = localStorage.getItem("poster-furl");
                    get_single_url = get_single_url.replace(siteUrl,"");
                    doc_t = await instance.Core.createDocument(get_single_url, { extension: type, loadAsPDF: true });                     
                    
                } else {                

                    img = document.createElement("img");
                    img.src = URL.createObjectURL(currFile);
        
                    img.onload = function (event) {
                        console.log(event);
                        console.log({ width: img.width, height: img.height });
                    };
        
                    img.src = URL.createObjectURL(currFile);

                    doc_t = await instance.Core.createDocument(currFile, { extension: fileType, loadAsPDF: true });
                }
    
                const annotX = 0;
                const annotY = 0;
    
                // create the stamp annotation
                let annot = new instance.Core.Annotations.StampAnnotation({
                    PageNumber: 1,
                    X: annotX,
                    Y: annotY,
                    Width: annotWidth,
                    Height: annotHeight,
                    MaintainAspectRatio: true,
                });
                setPostionXY(annotX, annotY, pageInfo.width, pageInfo.height); // SetPostion to be upload in server
    
                // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
                doc_t.loadCanvas({
                    pageNumber: 1,
                    zoom: 2,
                    drawComplete: async (image) => {
                        let data = useDataURL ? image.toDataURL() : image.src;
                        //annot.setImageData(data);
                        annot.setImageData(data);
                        instance.Core.annotationManager.addAnnotation(annot);
                        instance.Core.annotationManager.redrawAnnotation(annot);       
                        setIsFullLoading(false);                 
                    },
                });
    
                // add the annotation to the document and redraw it
                // instance.Core.annotationManager.addAnnotation(annot);
                // instance.Core.annotationManager.redrawAnnotation(annot);
            }

    
            //console.log(instance.Core.documentViewer.getPageCount());
            //await doc.removePages([1]);
            instance.Core.documentViewer.removeEventListener();

        }
            console.log('------- printFitSize --------');
            console.log('printFitSize: ', printFitSize);
            console.log('docHeight: ', docHeight);
            console.log('docWidth: ', docWidth);
            console.log('inputWidth: ', inputWidth);
            console.log('inputHeight: ', inputHeight);
            console.log('------- END printFitSize --------');

        return false;


    };

const calculateProportionalSize = async (hasOrientationChanged=false) => {
    if (!imgOrigWidth || !imgOrigHeight) {
        return;
    }

    let tempDocWidth = docWidth;
    let tempDocHeight = docHeight;
    if (hasOrientationChanged) {
        tempDocWidth = docHeight;
        tempDocHeight = docWidth;
    }

    console.log("-- -- Inside CalculateProportionalSize");
    let annotWidth = 0;
    let annotHeight = 0;
    let checkHeight =
        (imgOrigHeight / imgOrigWidth) * (tempDocWidth * MULT_NUM);
    let checkWidth =
        (imgOrigWidth / imgOrigHeight) * (tempDocHeight * MULT_NUM);

    if(inputHeight >= inputWidth) {
        let scale = imgOrigWidth / imgOrigHeight;
        annotWidth = checkWidth;
        annotHeight = (imgOrigHeight / imgOrigWidth) * (checkWidth);

        if(annotWidth > (tempDocWidth*MULT_NUM)) {
            annotWidth = (tempDocWidth*MULT_NUM);
            annotHeight = annotWidth / scale;
        }

    } else {
        let scale = imgOrigHeight / imgOrigWidth;
        annotHeight = checkHeight;
        annotWidth = (imgOrigWidth / imgOrigHeight) * (checkHeight);

        if(annotHeight > (tempDocHeight*MULT_NUM)) {
            annotHeight = (tempDocHeight*MULT_NUM);
            annotWidth = annotHeight / scale;
        }

    }

    

    let propwidth = Math.round(annotWidth / 72);
    let propheight = Math.round(annotHeight / 72);
    let propAR = propwidth / propheight; 
    let docAR = tempDocWidth / tempDocHeight;
    setProportionalWidth(propwidth);
    setProportionalHeight(propheight);
    console.log(' -=-=-=-=-=-=- WATCH HERE -=-=-=-=-=-=-=-');
    console.log('propwidth: ', propwidth);
    console.log('propheight: ', propheight)
    console.log('propAR: ', propAR);
    console.log('tempDocWidth: ', tempDocWidth);
    console.log('tempDocHeight: ', tempDocHeight);
    console.log('tempDocAR: ', docAR);

    const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;
    const roundedInputAR = roundToTwoDecimals(docAR);
    const roundedPropAR = roundToTwoDecimals(propAR);
    console.log('roundedInputAR: ', roundedInputAR);
    console.log('roundedPropAR', roundedPropAR);
   
    console.log('Comparing User InputAR: ', roundedInputAR, ' with "scales to PropAR: ', roundedPropAR);
    console.log('hasOrientationChanged: ', hasOrientationChanged);
    if (roundedInputAR === roundedPropAR) {
        console.log("Aspect Ratio matches perfectly");
        setIsExactMatch(true);
    }else{
        console.log("Aspect Ratio does NOT match");
        setIsExactMatch(false);
    }
    console.log(' -=-=-=-=-=-=- END WATCH HERE -=-=-=-=-=-=-=-');
    console.log("-- -- END Inside CalculateProportionalSize");

}

let hasRun = false;
const startOver = async () => {
    console.log("Inside startOver");
    console.log("hasRun: ", hasRun);
    if (hasRun) return;
    hasRun = true;
    if (window.location.hash === '#preview') {
        window.location.hash = '';
    }
    const queryParameters = new URLSearchParams(window.location.search);
    const from_single = queryParameters.get("from_single");      

    if(from_single === 'yes') {
        window.location.replace(localStorage.getItem("last-furl"));
    } else {
        window.location.reload();
    }

}

const toggleFitFill = async () => {
    setFitFill(!fitFill);

    if(fitFill) {
        //fit
        console.log('fillImageToDocument');
        fillImageToDocument();
    } else {
        //fill
        console.log('fillImagePropToDocument');
        fillImagePropToDocument();
    }

};

const toggleMobileLock = async () => {
    setMobileLock(!mobileLock);
}

const toggleAspectLock = async () => {
    setIsFullLoading(true);
    setAspectLock(!aspectLock);

    const instance = window.WebViewer.getInstance();
    const annotationManager =
        instance.Core.documentViewer.getAnnotationManager();
    const doc_temp = instance.Core.documentViewer.getDocument();
    let doc;
    let newHeight = docHeight;
    let newWidth = docWidth;
    let useDataURL = false;
    useDataURL = true;

    let type = 'jpg';
    const queryParameters = new URLSearchParams(window.location.search);
    const from_single = queryParameters.get("from_single");        

    await doc_temp.insertBlankPages(
        [1],
        newWidth * MULT_NUM,
        newHeight * MULT_NUM
    );
    await doc_temp.removePages([2]);

    if (currFile || from_single === 'yes') {

        if(from_single === 'yes') {
            let get_single_url = localStorage.getItem("poster-furl");
            get_single_url = get_single_url.replace(siteUrl,"");
            doc = await instance.Core.createDocument(get_single_url, { extension: type, loadAsPDF: true }); 

        } else {
            doc = await instance.Core.createDocument(currFile, { extension: fileType, loadAsPDF: true });
        }

        let pageInfo = doc.getPageInfo(1);
        let annotWidth = 0;
        let annotHeight = 0;
        let checkHeight =
            (imgOrigHeight / imgOrigWidth) * (newWidth * MULT_NUM);
        let checkWidth =
            (imgOrigWidth / imgOrigHeight) * (newHeight * MULT_NUM);

        if (newWidth >= newHeight) {
            annotWidth = checkWidth;
            annotHeight = (imgOrigHeight / imgOrigWidth) * checkWidth;
        } else {
            annotHeight = checkHeight;
            annotWidth = (imgOrigWidth / imgOrigHeight) * checkHeight;
        }

        const annotX = (newWidth * MULT_NUM) / 2 - annotWidth / 2;
        const annotY = (newHeight * MULT_NUM) / 2 - annotHeight / 2;

        // create the stamp annotation
        let annot = new instance.Core.Annotations.StampAnnotation({
            PageNumber: 1,
            X: annotX,
            Y: annotY,
            Width: annotWidth,
            Height: annotHeight,
            MaintainAspectRatio: aspectLock,
        });
        setPostionXY(annotX, annotY, pageInfo.width, pageInfo.height); // SetPostion to be upload in server
        // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
        doc.loadCanvas({
            pageNumber: 1,
            zoom: 2,
            drawComplete: async (image) => {
                let data = useDataURL ? image.toDataURL() : image.src;
                annot.setImageData(data);
                instance.Core.annotationManager.addAnnotation(annot);
                instance.Core.annotationManager.redrawAnnotation(annot);           
                setIsFullLoading(false);         
            },
        });

        // add the annotation to the document and redraw it
        // instance.Core.annotationManager.addAnnotation(annot);
        // instance.Core.annotationManager.redrawAnnotation(annot);
    }
};

const toggleLandPort = async () => {
    setIsFullLoading(true);
    setHasOrientationChanged(!hasOrientationChanged);
    setLandscapePort(!landscapePort);

    let tempInputHeight = inputHeight;

    setInputHeight(inputWidth);
    setInputWidth(tempInputHeight);

    setDocHeight(inputWidth);
    setDocWidth(inputHeight);


    // we use the helper function to create a PDF at a example size of 1000x1000
    //height and width reversed here

    //const instance = window.WebViewer.getInstance();
    //const annotationManager = instance.Core.documentViewer.getAnnotationManager()
    const doc_temp = instance.Core.documentViewer.getDocument();
    let doc;
    let img;
    let newHeight = 0;
    let newWidth = 0;
    let useDataURL = false;
    // let getFileUrl;
    // let base64;
    // let get_blob;
    // let blobUrl;
    // let data_url_dets;
    useDataURL = true;
    let type = 'jpg';
    const queryParameters = new URLSearchParams(window.location.search);
    const from_single = queryParameters.get("from_single");

    newHeight = inputWidth;
    newWidth = inputHeight;

    calculateProportionalSize(true); // Should send true the first time, and then toggle back and forth each time.

    await doc_temp.insertBlankPages(
        [1],
        newWidth * MULT_NUM,
        newHeight * MULT_NUM
    );
    await doc_temp.removePages([2]);

    if (currFile) {
        await instance.Core.PDFNet.initialize();

        img = document.createElement("img");

        if(from_single === 'yes') {        

        } else {
            img.src = URL.createObjectURL(currFile);
        }

        img.onload = function (event) {
            console.log(event);
            console.log({ width: img.width, height: img.height });
        };

        if(from_single === 'yes') {  
            let get_single_url = localStorage.getItem("poster-furl");
            get_single_url = get_single_url.replace(siteUrl,"");
            doc = await instance.Core.createDocument(get_single_url, { extension: type, loadAsPDF: true }); 

        } else {
            img.src = URL.createObjectURL(currFile);
            doc = await instance.Core.createDocument(currFile, { extension: fileType, loadAsPDF: true });
        }

        console.log('file type: ', fileType);

        let pageInfo = doc_temp.getPageInfo(1);

        let annotWidth = 0;
        let annotHeight = 0;
        let checkHeight =
            (imgOrigHeight / imgOrigWidth) * (newWidth * MULT_NUM);
        let checkHeightWidth = (imgOrigWidth / imgOrigHeight) * checkHeight;
        let checkWidth =
            (imgOrigWidth / imgOrigHeight) * (newHeight * MULT_NUM);
        let checkWidthHeight = (imgOrigHeight / imgOrigWidth) * checkWidth;
        let f_scale;

        if(!fitFill) {
            //fit
            console.log('first fitfill');

            f_scale = Math.min((newWidth*MULT_NUM) / imgOrigWidth, (newHeight*MULT_NUM) / imgOrigHeight);
        } else {
            //fill
            console.log('second fitfill');

            f_scale = Math.max((newWidth * MULT_NUM) / imgOrigWidth, (newHeight * MULT_NUM) / imgOrigHeight);
        }

        annotHeight = imgOrigHeight * f_scale;
        annotWidth = imgOrigWidth * f_scale;                   

        // const annotX = (newWidth * MULT_NUM) / 2 - annotWidth / 2;
        // const annotY = (newHeight * MULT_NUM) / 2 - annotHeight / 2;

        const annotX = ((newWidth * MULT_NUM) / 2) - (imgOrigWidth / 2) * f_scale;
        const annotY = ((newHeight * MULT_NUM) / 2) - (imgOrigHeight / 2) * f_scale;

        // create the stamp annotation
        let annot = new instance.Core.Annotations.StampAnnotation({
            PageNumber: 1,
            X: annotX,
            Y: annotY,
            Width: annotWidth,
            Height: annotHeight,
            MaintainAspectRatio: true,
        });
        
        setPostionXY(annotX, annotY, pageInfo.width, pageInfo.height); // SetPostion to be upload in server
        console.log("initial width: ", annotWidth);
        console.log("initial height: ", annotHeight);
        console.log("annotx: ", annotX);
        console.log("annoty: ", annotY);

        // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
        doc.loadCanvas({
            pageNumber: 1,
            zoom: 2,
            drawComplete: async (image) => {
                let data = useDataURL ? image.toDataURL() : image.src;
                //annot.setImageData(data);
                annot.setImageData(data);
                //console.log('data: ', data);

                instance.Core.annotationManager.addAnnotation(annot);
                instance.Core.annotationManager.redrawAnnotation(annot);          
                setIsFullLoading(false);          
            },
        });

        //let remove_annots = instance.Core.annotationManager.getAnnotationsList();
        //instance.Core.annotationManager.deleteAnnotations(remove_annots);

        // add the annotation to the document and redraw it
        //instance.Core.annotationManager.addAnnotation(annot);
        //instance.Core.annotationManager.redrawAnnotation(annot);
    }

    // console.log(instance.Core.documentViewer.getPageCount());
    //await doc.removePages([1]);
    instance.Core.documentViewer.removeEventListener();
};

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

const displayPdf = async (fileData, doc_m, instance, fileName, timestmp, origFile) => {
    let tempMediaInfo = getUserValues();
    let inputWidth = tempMediaInfo.selectedWidth;
    let inputHeight = tempMediaInfo.selectedHeight;
    console.log("displayPdf, inputWidth, inputHeight", inputWidth, inputHeight);
    console.log("tempMediaInfo, selectedWidth, selectedHeight", tempMediaInfo.selectedWidth, tempMediaInfo.selectedHeight);

    setIsPdf(true);
    let pdfSplit = fileName.split(".");
    console.log('filename check: ', pdfSplit[0].replace(" ","-") + pdfSplit[pdfSplit.length - 1]);
    var file = dataURLtoFile(
        fileData,
        pdfSplit[0] + ".jpg"
    );

    if (file) {
        setCurrFile(file);
        console.log("has file.");
        await instance.Core.PDFNet.initialize();
        console.log("after instance");
        let doc;
        let useDataURL = false;
        let img;
        let tempOrigHeight = 0;
        let tempOrigWidth = 0;
        useDataURL = true;

        img = document.createElement("img");
        img.src = URL.createObjectURL(file);

        img.onload = function (event) {
            console.log(event);
            console.log({ width: img.width, height: img.height });
            setImgOrigHeight(img.height);
            setImgOrigWidth(img.width);
            tempOrigHeight = img.height;
            tempOrigWidth = img.width;
        };

        let type = 'jpg';
        //let type = 'pdf';

        img.src = URL.createObjectURL(file);
        console.log("file type -->", file.type);
        // check the document type, and create a WebViewer document based on it
        //doc = await instance.Core.createDocument(file);
        doc = await instance.Core.createDocument(file, { extension: type, loadAsPDF: true });
        //doc = await instance.Core.createDocument(origFile, { extension: type, loadAsPDF: true });

        let pageInfo = doc_m.getPageInfo(1);

        // check if its wide or tall (width>height)
        console.log("page width: ", pageInfo.width);
        console.log("page height: ", pageInfo.height);
        // setImgHeight(pageInfo.height);
        // setImgWidth(pageInfo.width);

        let annotWidth = 0;
        let annotHeight = 0;
        let checkHeight =
            (tempOrigHeight / tempOrigWidth) * (inputWidth * MULT_NUM);
        let checkWidth =
            (tempOrigWidth / tempOrigHeight) * (inputHeight * MULT_NUM);


        checkHeight =
            (tempOrigHeight / tempOrigWidth) * (inputWidth * MULT_NUM);
        let checkHeightWidth = (tempOrigWidth / tempOrigHeight) * checkHeight;                        

        checkWidth =
        (tempOrigWidth / tempOrigHeight) * (inputHeight * MULT_NUM);
        let checkWidthHeight = (tempOrigHeight / tempOrigWidth) * checkWidth; 

        console.log('displaypdf ---->');
        console.log('MULT_NUM: ', MULT_NUM);
        console.log('docHeight: ', inputHeight);
        console.log('docWidth: ', inputWidth);
        console.log('checkHeight: ', checkHeight);
        console.log('doc_height * MULT: ', (inputHeight * MULT_NUM));
        console.log('checkHeightWidth: ', checkHeightWidth);
        console.log('docWidth * MULT: ', (inputWidth * MULT_NUM));            

        console.log('tempOrigHeight: ', tempOrigHeight);
        console.log('tempOrigWidth: ', tempOrigWidth);

        // if (
        //     //checkHeight >= (inputHeight * MULT_NUM) &&
        //     checkHeight >= (inputHeight * MULT_NUM) ||
        //     checkHeightWidth >= (inputWidth * MULT_NUM)
        // ) {
        //     console.log('displaypdf ----> first');
        //     annotHeight = checkHeight;
        //     annotWidth = checkHeightWidth;
        // } else {
        //     console.log('displaypdf ----> second');
        //     annotWidth = checkWidth;
        //     annotHeight = checkWidthHeight;
        // }            

        let f_scale = Math.max((inputWidth * MULT_NUM) / tempOrigWidth, (inputHeight * MULT_NUM) / tempOrigHeight);
        // get the top left position of the image
        
        annotHeight = tempOrigHeight * f_scale;
        annotWidth = tempOrigWidth * f_scale;                  

        const annotX = ((inputWidth * MULT_NUM) / 2) - (tempOrigWidth / 2) * f_scale;
        const annotY = ((inputHeight * MULT_NUM) / 2) - (tempOrigHeight / 2) * f_scale;            

        // create the stamp annotation
        const annot = new instance.Core.Annotations.StampAnnotation({
            PageNumber: 1,
            X: annotX,
            Y: annotY,
            Width: annotWidth,
            Height: annotHeight,
            MaintainAspectRatio: true,
        });
        setPostionXY(annotX, annotY, pageInfo.width, pageInfo.height); // SetPostion to be upload in server

        console.log("initial width: ", annotWidth);
        console.log("initial height: ", annotHeight);

        // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
        doc.loadCanvas({
            pageNumber: 1,
            zoom: 2,
            drawComplete: async (image) => {
                //console.log('drawcomplete image check: ', image);
                let data = useDataURL ? image.toDataURL() : image.src;
                //console.log("annot to add (pdf): ", data);
                setCurrImgData(data);
                annot.setImageData(data);

                instance.Core.annotationManager.addAnnotation(annot);
                instance.Core.annotationManager.redrawAnnotation(annot);   
                setWebviewerLoading(false);                 

            },
        });

        console.log("initial annot to add: ", annot);

        // add the annotation to the document and redraw it
        // instance.Core.annotationManager.addAnnotation(annot);
        // instance.Core.annotationManager.redrawAnnotation(annot);

        console.log("before step2webv");
        window.location.hash = '#preview';
        //Hide first step, show second step
        document.getElementById("uploadButton").classList.add("hide");
        document.body.classList.add("step2body");
        const step1 = document.querySelectorAll('.step1webvstamp'); // Hide the additional sections
        const step2 = document.querySelectorAll('.step2webvstamp'); // Show the webviewer 
        // step1.forEach(element => {
        //     element.classList.add('hidden-element');
        // });
        step1.forEach(element => { // When the file input receives a new file, hide step1 and show step2
            element.style.position = 'absolute';
            element.style.left = '-100%';
            element.style.visibility = 'hidden';
            element.style.height = '0';
            // element.style.minHeight = '0';
            element.style.display = 'none';
        });
        step2.forEach(element => {
        //   element.style.display = 'block';
            element.style.visibility = 'visible';
            element.style.height = 'auto';
            element.style.minHeight = '0';
        }); 

        setHasImage(true);
        setIsFullLoading(false);
        uploadImage(file, 'pdf', timestmp, ''); //uncomment on deploy
        window.scrollTo({ top: 0, left: 0});
    }
    instance.Core.documentViewer.removeEventListener();
};

const createImage = async (e) => {
    const instance = window.WebViewer.getInstance();
    // const { documentViewer, /* annotationManager */ } = instance.Core;

    let tempMediaInfo = getUserValues();

    let inputWidth = tempMediaInfo.selectedWidth;
    let inputHeight = tempMediaInfo.selectedHeight;
    console.log("createImage, inputWidth, inputHeight", inputWidth, inputHeight);
    console.log("tempMediaInfo, selectedWidth, selectedHeight", tempMediaInfo.selectedWidth, tempMediaInfo.selectedHeight);

    console.log("createImage, tempMediaInfo", tempMediaInfo);
    console.log("createImage, mediaInfo", mediaInfo);

    // grabs the file that was selected
    let highestWH = 0;
    let check_file = e.target.files[0];
    let check_file_type = check_file?.type;
    //console.log('file details: ', check_file);
    console.log('file type: ', check_file?.type);
    console.log('name: ', check_file.name);
    console.log("e.target: ", e.target);
    setOrigFName(check_file.name);
    // setFileDisplayName(check_file.name);
    let type = 'jpg'; //SPHEX CHANGE THIS
    let timestmp = Date.now();

    console.log('check size --> ', check_file?.size);

    if (check_file?.size > 300 * 1000 * 1024) {
    //if (check_file?.size > 5 * 1000 * 1024) {

        var sizeInMB = (check_file?.size / (1024*1024)).toFixed(2);
        document.getElementById("enter-size-title-clicker").title = sizeInMB;

        //var element = document.getElementById("large-size-popup");
        //element.classList.add("active-popup");
        //updateShowPopup.current.click();
        updateShowPopup.current.click();            
        //updateShowPopupChecker.current.click();

        var elem = document.querySelector('.size-text');
        // var html = elem.innerHTML;
        elem.innerHTML = sizeInMB;

        console.log('check size__ --> ');

        setTimeout(function() {
            //write.current.click();                
            //console.log('with delay --> ');
        }, 2000);            

        return false;
    }

    setIsFullLoading(true);

    let message = '';
    if(check_file_type === 'image/jpeg') {
        type = 'jpg';
    } else if(check_file_type === 'image/png') {
        type = 'png';
    } else if(check_file_type === 'image/tiff') {
        type = 'tiff';
    } else if(check_file_type === 'application/pdf') {
        setProofType('pdf');
    } else {
        setIsFullLoading(false);
        message = "invalidError: Invalid MIME Type: "+ check_file_type;
        showErrorModal(message, "invalidError");
        // alert('Please upload a valid image file (jpg, png, tiff or PDF)');
        return false;
    }
    const validExtensions = ['jpg', 'jpeg', 'png', 'tiff', 'tif', 'pdf'];
    const fileExtension = check_file.name.split('.').pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
        setIsFullLoading(false);
        message = "invalidError: "+ fileExtension + " is invalid.";
        showErrorModal(message, "invalidError");
        // alert('Invalid file type. Please upload a valid image file (jpg, jpeg, png, tiff, tif, or pdf).');
        return false;
    }

    setFileType(type);

    if(type === 'tiff') {
        setLoadingTiff(true);
        setIsTiff(true);            
    }
    

    // this is a helper function you can use to create a document of whatever height and width you need.
    let createPDFTemp = async (width, height) => {
        const pdfDoc = await instance.Core.PDFNet.PDFDoc.create();
        const pdfPage = await pdfDoc.pageCreate(
            new instance.Core.PDFNet.Rect(0, 0, width, height)
        );
        await pdfDoc.pagePushFront(pdfPage);

        let temp_type = '';
        if(type === 'tiff')
            temp_type = 'jpg';
        else
            temp_type = type;
        
        const doc = instance.Core.createDocument(pdfDoc, { extension: temp_type, loadAsPDF: true });

        return doc;
    };

    setDocHeight(inputHeight);
    setDocWidth(inputWidth);

    if (inputWidth > inputHeight) {
        highestWH = inputWidth;
    } else {
        highestWH = inputHeight;
    }

    instance.Core.documentViewer.loadDocument(
        await createPDFTemp(highestWH * MULT_NUM, highestWH * MULT_NUM)
    );

    instance.Core.documentViewer.addEventListener(
        "documentLoaded",
        async () => {
            //alert('loaded setimage');
            let tempMediaInfo = getUserValues();

            let inputWidth = tempMediaInfo.selectedWidth;
            let inputHeight = tempMediaInfo.selectedHeight;
            console.log("documentLoaded, inputWidth, inputHeight", inputWidth, inputHeight);
            console.log("tempMediaInfo, selectedWidth, selectedHeight", tempMediaInfo.selectedWidth, tempMediaInfo.selectedHeight);

            const doc_m = instance.Core.documentViewer.getDocument();
            await doc_m.insertBlankPages(
                [1],
                inputWidth * MULT_NUM,
                inputHeight * MULT_NUM
            );
            await doc_m.removePages([2]);

            const file = e.target.files[0];
            console.log('file  -->', file)
            
            if (file?.type === "application/pdf") {
                uploadImage(file,'',timestmp, ''); //uncomment before deploy
                const file_url = URL.createObjectURL(file);

                console.log('file url: ', file_url);

                fetch(file_url).then((response) => {
                    response.blob().then((blob) => {
                        let reader = new FileReader();
                        reader.onload = async (e) => {
                            const data = atob(
                                e.target.result.replace(/.*base64,/, "")
                            );
                            const imagesList = [];
                            const canvas = document.createElement("canvas");
                            canvas.setAttribute("className", "canv");
                            const pdf = await getDocument({ data }).promise;
                            for (let i = 1; i <= 1; i++) {
                                var page = await pdf.getPage(i);
                                var viewport = page.getViewport({
                                    scale: 1.5,
                                    //scale: 1.0,
                                });

                                /*if(viewport.width > viewport.height) {
                                    let g_ratio = (inputWidth * MULT_NUM) / viewport.width;
                                    let g_height = viewport.height * g_ratio;
                                    let g_width = viewport.width * g_ratio;
                                    canvas.height = g_height;
                                    canvas.width = g_width;
                                } else {*/
                                    canvas.height = viewport.height;
                                    canvas.width = viewport.width;
                                //}

                                var render_context = {
                                    canvasContext: canvas.getContext("2d"),
                                    viewport: viewport,
                                };
                                await page.render(render_context).promise;
                                let img = canvas.toDataURL("image/png", 1.0);
                                imagesList.push(img);
                            }
                            displayPdf(imagesList[0], doc_m, instance, file.name, timestmp, file);
                        };
                        reader.readAsDataURL(blob);
                    });
                }).catch((error) => {
                    console.log(error);
                    alert('error');
                });
                return;
            }
            

            let doc;
            let useDataURL = false;
            let img;
            let tempOrigHeight = 0;
            let tempOrigWidth = 0;              
            
            // get the first page
            let pageInfo = doc_m.getPageInfo(1);                
            
            if (file) {
                setCurrFile(file);
                //uploadImage(file);
                await instance.Core.PDFNet.initialize();
                console.log("after instance");
                useDataURL = true;

                    img = document.createElement("img");
                    img.src = URL.createObjectURL(file);

                    img.onload = function (event) {
                        console.log(event);
                        console.log({ width: img.width, height: img.height });
                        setImgOrigHeight(img.height);
                        setImgOrigWidth(img.width);
                        tempOrigHeight = img.height;
                        tempOrigWidth = img.width;
                    };

                    img.src = URL.createObjectURL(file);

                    console.log('check type ---> ', type);

                    // check the document type, and create a WebViewer document based on it
                    console.log('annot type: ', type);
                    doc = await instance.Core.createDocument(file, { extension: type, loadAsPDF: true });
                /* } */

                //await doc.insertBlankPages([1], inputWidth, inputHeight);
                //await doc.removePages([2]);

                //alert(tempOrigHeight);

                // check if its wide or tall (width>height)
                console.log("page width: ", pageInfo.width);
                console.log("page height: ", pageInfo.height);
                    setImgHeight(pageInfo.height);
                    setImgWidth(pageInfo.width);

                if(type === 'tiff') {
                    console.log('tiff');
                    tempOrigHeight = 4000;
                    tempOrigWidth = 4000;                        
                    setImgOrigHeight(4000);
                    setImgOrigWidth(4000);                        
                }     


                let annotWidth = 0;
                let annotHeight = 0;
                let checkHeight =
                    (tempOrigHeight / tempOrigWidth) *
                    (inputWidth * MULT_NUM);
                let checkWidth =
                    (tempOrigWidth / tempOrigHeight) *
                    (inputHeight * MULT_NUM);

                checkHeight =
                    (tempOrigHeight / tempOrigWidth) * (inputWidth * MULT_NUM);
                let checkHeightWidth = (tempOrigWidth / tempOrigHeight) * checkHeight;                        

                checkWidth =
                (tempOrigWidth / tempOrigHeight) * (inputHeight * MULT_NUM);
                let checkWidthHeight = (tempOrigHeight / tempOrigWidth) * checkWidth;     
                
                console.log('img height: ', tempOrigHeight);
                console.log('img width: ', tempOrigWidth);
                console.log('doc width: ', inputWidth);
                console.log('doc height: ', inputHeight);                    
                
                instance.Core.Tools.Tool.ALLOW_ANNOTS_OUTSIDE_PAGE = true;

                let f_scale = Math.max((inputWidth * MULT_NUM) / tempOrigWidth, (inputHeight * MULT_NUM) / tempOrigHeight);
                // get the top left position of the image
                let annotX = ((inputWidth * MULT_NUM) / 2) - (tempOrigWidth / 2) * f_scale;
                let annotY = ((inputHeight * MULT_NUM) / 2) - (tempOrigHeight / 2) * f_scale;

                annotHeight = tempOrigHeight * f_scale;
                annotWidth = tempOrigWidth * f_scale;       

                console.log('annotWidth ***: ', annotWidth);
                console.log('annotHeight ***: ', annotHeight);

                console.log('annotx: ', annotX);
                console.log('annoty: ', annotY);

                                // create the stamp annotation
                const annot = new instance.Core.Annotations.StampAnnotation(
                    {
                        PageNumber: 1,
                        X: annotX,
                        Y: annotY,
                        Width: annotWidth,
                        Height: annotHeight,
                        MaintainAspectRatio: true,
                    }
                );
                
                setPostionXY(
                    annotX,
                    annotY,
                    pageInfo.width,
                    pageInfo.height
                ); // SetPostion to be upload in server

                // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
                doc.loadCanvas({
                    pageNumber: 1,
                    zoom: 2,
                    drawComplete: async (image) => {
                        //console.log('drawcomplete image check: ', image);
                        let data = useDataURL
                            ? image.toDataURL()
                            : image.src;
                        //setCurrImgData(data);
                        annot.setImageData(data);
                        //console.log('data check (imgg): ', data);
                        if(useDataURL) {
                            console.log('use data url');
                        } else {
                            console.log('not using data url.');
                        }

                        instance.Core.annotationManager.addAnnotation(annot);
                        instance.Core.annotationManager.redrawAnnotation(annot);
                        setWebviewerLoading(false);                 

                        console.log('____after add annotation --> :', type);

                        if(type !== 'tiff')
                            setIsFullLoading(false);

                    },
                });

                await sleep(1000);

                const { annotationManager } = instance.Core;
                let annots = annotationManager
                    .getAnnotationsList()
                    .filter((annot) => annot.PageNumber === 1);
                annotationManager.selectAnnotations(annots);       
                let currentlySelectedAnnotationSingle =
                    annotationManager.getSelectedAnnotations()[0];    
                    
                setHasImage(true);

                window.location.hash = '#preview';
                console.log("before step2webv");
                //Hide first step, show second step
                document.getElementById("uploadButton").classList.add("hide");
                // document.body.classList.add("step2body");
                const step1 = document.querySelectorAll('.step1webvstamp'); // Hide the additional sections
                const step2 = document.querySelectorAll('.step2webvstamp'); // Show the webviewer 
                // step1.forEach(element => {
                //     element.classList.add('hidden-element');
                // });
                step1.forEach(element => { // When the file input receives a new file, hide step1 and show step2
                    element.style.visibility = 'hidden';
                    element.style.height = '0';
                    // element.style.display = 'none';
                    element.style.position = 'absolute';
                    element.style.left = '-100%';
                    element.style.display = 'none';
                });
                step2.forEach(element => {
                //   element.style.display = 'block';
                    element.style.visibility = 'visible';
                    element.style.height = 'auto';
                }); 

                console.log('check type ---> ', type);
                let decode_check = true;
                let tiff_upload_dets;
                // let get_tiff;
                if(type === 'tiff') {

                    const fr = new FileReader();
                    fr.onload = async function (f) {
                        const arrayBuffer = await f.target.result;
                        const buf = Buffer.from(arrayBuffer);
                        //console.log('buf debug: ', decode(buf));
                        let tiff_dets = {width: 300, height: 300};
                    
                        try {
                            tiff_dets = decode(buf);
                        } catch (error) {
                        console.log('decode error');
                        decode_check = false;
                        tiff_dets.width = 900;
                        tiff_dets.height = 900;
                        }
                        //resolve(decode(buf))

                        setLoadingTiff(true);
                        setIsTiff(true);
                        console.log('is tiff');
                        setIsFullLoading(true);

                        if(!decode_check) {
                        tiff_upload_dets = await uploadImage(file);
                        console.log('dets tiff --> ', tiff_upload_dets);
                        console.log('dets tiff width --> ', tiff_upload_dets[0]);
                        tiff_dets.width = tiff_upload_dets[0];
                        tiff_dets.height = tiff_upload_dets[1];                            
                        } else {
                        uploadImage(file);
                        }
                        
                        //let tiff_dets = await uploadImage(file);

                        annots = annotationManager
                        .getAnnotationsList()
                        .filter((annot) => annot.PageNumber === 1);
                        annotationManager.selectAnnotations(annots);       
                        currentlySelectedAnnotationSingle = annotationManager.getSelectedAnnotations()[0]; 
                        console.log('tiff width: ', tiff_dets.width);
                        console.log('tiff height__: ', tiff_dets.height);
                        tempOrigHeight = tiff_dets.height;
                        tempOrigWidth = tiff_dets.width;                        
                        setImgOrigHeight(tiff_dets.height);
                        setImgOrigWidth(tiff_dets.width);                            


                        checkHeight =
                            (tempOrigHeight / tempOrigWidth) *
                            (inputWidth * MULT_NUM);
                        checkWidth =
                            (tempOrigWidth / tempOrigHeight) *
                            (inputHeight * MULT_NUM);
    
                        checkHeight =
                            (tempOrigHeight / tempOrigWidth) * (inputWidth * MULT_NUM);
                        let checkHeightWidth = (tempOrigWidth / tempOrigHeight) * checkHeight;                        
    
                        checkWidth =
                        (tempOrigWidth / tempOrigHeight) * (inputHeight * MULT_NUM);
                        let checkWidthHeight = (tempOrigHeight / tempOrigWidth) * checkWidth;     
    
                        if (
                            checkHeight >= inputHeight * MULT_NUM &&
                            checkHeightWidth >= inputWidth * MULT_NUM
                        ) {
                            annotHeight = checkHeight;
                            annotWidth = checkHeightWidth;
                        } else {
                            annotWidth = checkWidth;
                            annotHeight = checkWidthHeight;
                        }
                
                        annotX = (inputWidth * MULT_NUM) / 2 - annotWidth / 2;
                        annotY = (inputHeight * MULT_NUM) / 2 - annotHeight / 2;   
                        
                        setIsFullLoading(false);
                        setLoadingTiff(false);

                        currentlySelectedAnnotationSingle.setWidth(annotWidth);
                        currentlySelectedAnnotationSingle.setHeight(annotHeight);  

                        currentlySelectedAnnotationSingle.setX(annotX);
                        currentlySelectedAnnotationSingle.setY(annotY);

                    };
                    fr.readAsArrayBuffer(file);                        

                }               
                
                //setHasImage(true);

                if(type !== 'tiff') {
                    uploadImage(file); //sphex uncomment on deploy
                }
                
                window.scrollTo({ top: 0, left: 0});
            } else {
                console.log("no file.");
            }

            instance.Core.documentViewer.removeEventListener();
        }
    );

    //return () => instance.Core.documentViewer.removeEventListener('documentLoaded');
};

const fillImageToDocument = () => {
    console.log("fillImageToDocument  ==================--->");

    const instance = window.WebViewer.getInstance();
    const doc = instance.Core.documentViewer.getDocument();
    let pageInfo = doc.getPageInfo(1);

    const { annotationManager } = instance.Core;
    const annots = annotationManager
        .getAnnotationsList()
        .filter((annot) => annot.PageNumber === 1);
    annotationManager.selectAnnotations(annots);
    const currentlySelectedAnnotation =
        annotationManager.getSelectedAnnotations()[0];

    // const oldHeight = imgOrigHeight;
    // const oldWidth = imgOrigWidth;

    console.log('docwidth: ', docWidth);
    console.log('docheight: ', docHeight);
    console.log('imgOrigHeight: ', imgOrigHeight);
    console.log('imgOrigWidth: ', imgOrigWidth);        

    let annotWidth = 0;
    let annotHeight = 0;
    let checkHeight =
        (imgOrigHeight / imgOrigWidth) * (docWidth * MULT_NUM);
    let checkWidth =
        (imgOrigWidth / imgOrigHeight) * (docHeight * MULT_NUM);

        let f_scale = Math.min((docWidth*MULT_NUM) / imgOrigWidth, (docHeight*MULT_NUM) / imgOrigHeight);
        // get the top left position of the image
        let annotX = ((docWidth*MULT_NUM) / 2) - (imgOrigWidth / 2) * f_scale;
        let annotY = ((docHeight*MULT_NUM) / 2) - (imgOrigHeight / 2) * f_scale;
        //ctx.drawImage(img, x, y, img.width * scale, img.height * scale);            

        annotHeight = imgOrigHeight * f_scale;
        annotWidth = imgOrigWidth * f_scale;            
    console.log('annotWidth: ', annotWidth);
    console.log('annotHeight: ', annotHeight);

    currentlySelectedAnnotation.setWidth(annotWidth);
    currentlySelectedAnnotation.setHeight(annotHeight);

    currentlySelectedAnnotation.setX(annotX);
    currentlySelectedAnnotation.setY(annotY);
    annotationManager.redrawAnnotation(currentlySelectedAnnotation);
    console.log({pageInfo})
    setPostionXY(annotX, annotY, pageInfo.width, pageInfo.height); // SetPostion to be upload in server
    // setPostionXY(annotX, annotY, 100, 100);
};

const fillImagePropToDocument = () => {
    const instance = window.WebViewer.getInstance();
    const { annotationManager } = instance.Core;
    const annots = annotationManager
        .getAnnotationsList()
        .filter((annot) => annot.PageNumber === 1);
    annotationManager.selectAnnotations(annots);
    const currentlySelectedAnnotation =
        annotationManager.getSelectedAnnotations()[0];

    // const oldHeight = currentlySelectedAnnotation.getHeight();
    // const oldWidth = currentlySelectedAnnotation.getWidth();

    // let ratio = 0;
    let x_pos = 0;
    let y_pos = 0;

    let annotWidth = 0;
    let annotHeight = 0;
    // let checkHeight =
    //     (imgOrigHeight / imgOrigWidth) * (docWidth * MULT_NUM);
    // let checkHeightWidth = (imgOrigWidth / imgOrigHeight) * checkHeight;

    // let checkWivdth =
        // (imgOrigWidth / imgOrigHeight) * (docHeight * MULT_NUM);
    // let checkWidthHeight = (imgOrigHeight / imgOrigWidth) * checkWidth;

    // console.log("checkWidthHeight: ", checkWidthHeight);
    console.log('img height: ', imgOrigHeight);
    console.log('img width: ', imgOrigWidth);
    console.log('doc width: ', docWidth);
    console.log('doc height: ', docHeight);

    let f_scale = Math.max((docWidth * MULT_NUM) / imgOrigWidth, (docHeight * MULT_NUM) / imgOrigHeight);
    // get the top left position of the image
    x_pos = ((docWidth * MULT_NUM) / 2) - (imgOrigWidth / 2) * f_scale;
    y_pos = ((docHeight * MULT_NUM) / 2) - (imgOrigHeight / 2) * f_scale;
    
    annotHeight = imgOrigHeight * f_scale;
    annotWidth = imgOrigWidth * f_scale;        

    currentlySelectedAnnotation.setWidth(annotWidth);
    currentlySelectedAnnotation.setHeight(annotHeight);

    console.log('annotWidth: ', annotWidth);
    console.log('annotHeight: ', annotHeight);        

    // x_pos = (docWidth * MULT_NUM) / 2 - annotWidth / 2;
    // y_pos = (docHeight * MULT_NUM) / 2 - annotHeight / 2;

    currentlySelectedAnnotation.setX(x_pos);
    currentlySelectedAnnotation.setY(y_pos);
    const doc = instance.Core.documentViewer.getDocument();
    let pageInfo = doc.getPageInfo(1);
    setPostionXY(x_pos, y_pos, pageInfo.width, pageInfo.height); // SetPostion to be upload in server

    annotationManager.redrawAnnotation(currentlySelectedAnnotation);
};

const sleep = ms => new Promise(r => setTimeout(r, ms));

// const errorPopup = async (res, message) => {
//     setLoading(false);
//     setIsFullLoading(false);
//     await new Promise(resolve => setTimeout(resolve, 100));
//     // setHasImage(false);
//     console.log('error: ', res.data);
//     console.log('error: ', res.data.error);
//     console.log('error: ', res.data.message);
//     const advancedOrderWizardUrl = process.env.REACT_APP_ADVANCED_ORDER_WIZARD_URL || `${window.location.origin}/advanced-order/`;
//     alert(message);
// }

const showErrorModal = async (message, errorType) => {
    setLoading(false);
    setIsFullLoading(false);
    await new Promise(resolve => setTimeout(resolve, 100));

    setErrorMessage(message);
    setErrorType(errorType);
    setIsErrorModalVisible(true);
    
    if (window.LogRocket) {
        // window.LogRocket.track('error', {
        //     message: message,
        //     errorType: errorType,
        // });
        message = "reactError - " + message;
        console.log('LogRocket error tracking:', message);
        // console.log(window.LogRocket);
        window.LogRocket.captureMessage(message, {
            tags: {
              // additional data to be grouped as "tags"
              errorType: errorType,
            },
            extra: {
              // additional arbitrary data associated with the event
              errorType: errorType,
              error: message,
            },
          });
    }
};


const dumpInfoToConsole = async () => {

    /*this.formRef.dispatchEvent(
        new Event("submit", { bubbles: true, cancelable: true })
    ) */       

    //this.refs.posterForm.getdomnode().dispatchevent("submit");
    //formEl.current.submit();
    console.log('download proof --->');
    
    const instance = window.WebViewer.getInstance();
    const annotationManager =
        instance.Core.documentViewer.getAnnotationManager();
    // const doc = instance.Core.documentViewer.getDocument();

    const annots = annotationManager
        .getAnnotationsList()
        .filter((annot) => annot.PageNumber === 1);
    annotationManager.selectAnnotations(annots);

    const currentlySelectedAnnotation =
        annotationManager.getSelectedAnnotations()[0];

    const imgHeight = currentlySelectedAnnotation.getHeight();
    const imgWidth = currentlySelectedAnnotation.getWidth();

    console.log("checking...");

    console.log(imgHeight);
    console.log(imgWidth);

    console.log(currentlySelectedAnnotation.getX());
    console.log(currentlySelectedAnnotation.getY());

    /*instance.UI.downloadPdf({
        includeAnnotations: true,
        flatten: true,
        });        
    */

    //return false;

    if(proofType === 'pdf') {
        setIsFullLoading(true);
        console.log('download proof for PDF ------>');
        const docHeight = inputHeight * MULT_NUM;
        const docWidth = inputWidth * MULT_NUM;
        const imgHeight = currentlySelectedAnnotation.getHeight();
        const imgWidth = currentlySelectedAnnotation.getWidth();
        const imgX = currentlySelectedAnnotation.getX();
        const imgY = currentlySelectedAnnotation.getY();
        
        let res = await API.generatePDFOnlyProof(
            urlImage.current,
            docHeight,
            docWidth,
            imgHeight,
            imgWidth,
            imgX,
            imgY
        );

        if (res.data.status === "success") {
            setLoading(false);

            let url = res.data.url;
            let filename = "pps-proof.pdf";

            axios
                .get(url, {
                    responseType: "blob",
                })
                .then((res) => {
                    console.log('blob check all: ', res);
                    console.log('blob check: ', res.data);
                    fileDownload(res.data, filename);
                    setIsFullLoading(false);
                });
        }else{
            let message = "proofError: " + res.data.message;
            // errorPopup(res, message);
            showErrorModal(message, "proofError");
        }

    } else if(fileType !== 'tiff') { //default if not tiff and pdf
        const selected = annotationManager.getSelectedAnnotations();
        const xfdfString = await annotationManager.exportAnnotations({ annotationList: selected });     
        //const xfdfString = await annotationManager.exportAnnotations();

        //console.log('before sleep 10 seconds');
        //await sleep(10000);
        //console.log('after sleep 10 seconds');
        
        const options = {
            filename: "pps-proof.pdf",
            xfdfString,
            flags: instance.Core.SaveOptions.LINEARIZED,
            downloadType: "pdf",
        };

        console.log('download options: ', options);
        //console.log('download xfd: ', xfdfString);
        console.log('download pdf with await.');

        await instance.UI.downloadPdf(options);
        console.log("download?");
    } else {
        setIsFullLoading(true);
        console.log('download proof for TIFF ------>');
        const docHeight = inputHeight * MULT_NUM;
        const docWidth = inputWidth * MULT_NUM;
        const imgHeight = currentlySelectedAnnotation.getHeight();
        const imgWidth = currentlySelectedAnnotation.getWidth();
        const imgX = currentlySelectedAnnotation.getX();
        const imgY = currentlySelectedAnnotation.getY();
        
        let res = await API.generatePDFProof(
            urlImage.current,
            docHeight,
            docWidth,
            imgHeight,
            imgWidth,
            imgX,
            imgY
        );

        if (res.data.status === "success") {
            setLoading(false);

            let url = res.data.url;
            let filename = "pps-proof.pdf";

            axios
                .get(url, {
                    responseType: "blob",
                })
                .then((res) => {
                    console.log('blob check all: ', res);
                    console.log('blob check: ', res.data);
                    fileDownload(res.data, filename);
                    setIsFullLoading(false);
                });
        }else{
            let message = "proofError: " + res.data.message;
            // errorPopup(res, message);
            showErrorModal(message, "proofError");
        }            
    }

};

// const changeFile = () => {
//     console.log("----- Inside of changeFile -----");
//     // resetOrigImageData(); // Reset the original image data
//     // resetFinalImageData(); // Reset the final image data
//     resetUploadedFile(); // Reset the final image data

//     // isExactMatch && setIsExactMatch(false); // Reset the exact match state

//     // setTimeout(() => {
//     //   dumpFormData(); // Dump data to console for debugging
//     // }, 1500);
    
//     // This function will be called when the user clicks the "Change File" button
//     document.getElementById("file-picker").click();
//     console.log("Change File button clicked");
//     // setIsCropApplied(false); // Reset the crop applied state
// }

const resetUploadedFile = () => {
    console.log('----- Inside of resetUploadedFile -----');
    // <input type="file" id="fileInput" accept="image/*,application/pdf"></input>
    const filePicker = document.getElementById("file-picker");
    if (filePicker) {
        filePicker.value = ""; // unset the file input so that users can upload the same file again
    }
    };


useEffect(() => {
    console.log("start!!!");
    const queryParameters = new URLSearchParams(window.location.search);
    const from_single = queryParameters.get("from_single");
    const p_w = queryParameters.get("width");
    const p_h = queryParameters.get("height");
    const t_w = queryParameters.get("tiff_w");
    const t_h = queryParameters.get("tiff_h");
    const prod_price = queryParameters.get("price");
    const smedia = queryParameters.get("smedia");
    const prod_id = queryParameters.get("prodid");
    const pres_img_url = queryParameters.get("imgurl");
    const ispdf = queryParameters.get("ispdf");

    //console.log('test: ', test);

    if(from_single === 'yes') {
        setDocHeight(p_h);
        setDocWidth(p_w);
        setInputHeight(p_h);
        setInputWidth(p_w);            
        setIsFullLoading(true);
        setHasImage(true);
    }

    if(ispdf === 'yes') {
        setProofType('pdf');
    }

    axios.post(`${siteUrl}/wp-content/plugins/ppsposter-react/inc/get_product_price.php?get_p_list=yes`, null, { params: {
        get_p_list: 'yes'
        } } )
        .then((response) => {
        console.log('check --> ', response.data );
        setMediaList(response.data);

        let temp_media_list = response.data;
        let temp_arr = []

        temp_media_list.map(function(data) {
            temp_arr.push({ id: data.id, val: data.val, label: data.label, permalink: data.permalink, url: data.url, prodid: data.prodid });
        });

        setMediaListFinal([...mediaListFinal, ...temp_arr]);
    });         
    

    // if (document.body.classList.contains('single-product')) {
    //     console.log('Single Product or Service');
    //     document.addEventListener('change', function (event) {
    //         if (event.target.name === 'poster_media_size') {
    //             console.log('CHANGE SIZE poster_media_size' );
    //             let tempMediaInfo = getUserValues();
    //             console.log('event', event);
    //             // setInputWidth(tempMediaInfo.selectedWidth);
    //             // setInputHeight(tempMediaInfo.selectedHeight);
    //             // setDocWidth(tempMediaInfo.selectedWidth);
    //             // setDocHeight(tempMediaInfo.selectedHeight);

    //         }
    //     });
    // }else{ 
    //     document.addEventListener('click', function (event) {
    //         if (event.target.name === 'poster_media_size') {
    //             getUserValues();
    //         }
    //     });
    //     document.addEventListener('click', function (event) {
    //         if (event.target.name === 'poster_media') {
    //             getUserValues();
    //         }
    //     });
    // }

    if (document.getElementById('poster_media_size_custom_width')) {
        console.log("width change triggered");
        document.getElementById('poster_media_size_custom_width').addEventListener('change', getUserValues);
    }
    if (document.getElementById('poster_media_size_custom_height')) {
        console.log("height change triggered");
        document.getElementById('poster_media_size_custom_height').addEventListener('change', getUserValues);
    }
    //.DocumentContainer

    WebViewer(
        {
            //path: "/webviewer/lib", //use this when working locally
            path: '/wp-content/plugins/ppsposter-react/react/webviewer/lib', //use this when uploading to WP
            css: "/wp-content/plugins/ppsposter-react/react/webviewer/stampInnerCss.css",
            //path: 'https://x1.posterprintshop.com/react/webviewer/lib/',
            //licenseKey: 'demo:1688702627632:7c64e41e030000000085cda183986d848d66aa9cd97b0e1fb90d72f475',
            licenseKey: licenseKey,
            fullAPI: true,
            disabledElements: ["toolsHeader", "header", "annotationPopup", "toolsOverlay"],
            // initialDoc: 'https://pps.local/wp-content/uploads/webvr/androidphotoportrait2---3060-x-4080-1740643317.jpg',
        },
        viewer.current
    ).then(async (instance) => {
        console.log("webviewer then");

        

        window.instance = instance;
        const { documentViewer } = instance.Core;
    
        function getFirefoxVersion() {
            const ua = navigator.userAgent;
            const match = ua.match(/Firefox\/(\d+)\./);
            return match ? parseInt(match[1], 10) : null;
        }
        
        const version = getFirefoxVersion();
        
        if(version && version > 145) {
            console.log('Disabling virtual display mode for Firefox version', version);
            const displayMode = documentViewer.getDisplayModeManager();
            displayMode.disableVirtualDisplayMode();
        }



        instance.UI.disableElements([
            'default-top-header', 'snippingToolButton', 'tools-header', 'page-nav-floating-header', 'toolsOverlay', /* 'toolsOverlay', 'page-nav-floating-header', 'documentCropPopup', 'toolsHeader', 'header', 'annotationPopup' */
        ]);
        //const annotationManager = instance.Core.documentViewer.getAnnotationManager();
        const { annotationManager } = instance.Core;
        
        annotationManager.addEventListener('annotationChanged', async (annotations, action) => {
            
            
            if (action === 'add') {
                
                const selected = annotationManager.getSelectedAnnotations();
                let get_xfdfString = await annotationManager.exportAnnotations({ annotationList: selected });

                // console.log(get_xfdfString);
                setForExport(get_xfdfString);
            }
            
            //alert(action);
            
        });
        
        setInstance(instance);
        // const { documentViewer, Tools, Annotations, /*cropAnnotation */} = instance.Core;

        // Start the full workers
        await instance.Core.PDFNet.initialize();


        if (!isDevelopment) {
            const uploadButton = document.querySelector("#uploadButton");
            const uploadLoadingCircle = document.querySelector("#upload-loading-circle");
            if (uploadButton) {
                uploadButton.classList.remove("hide"); // Hide the file upload section
            }
            if (uploadLoadingCircle) {
                uploadLoadingCircle.classList.add("hide"); // Hide the spinner when Webviewer is loaded
            }
        }

        document.getElementById("fileInput").addEventListener("change", async function(event) { // Listen for changes to file upload input
            console.log("------ - - - Inside fileInput change Event");
            // let check_file = event.target.files[0];
            // let check_file_type = check_file?.type;
            // let file_extension = "";
            // //console.log('file details: ', check_file);
            // console.log('file data: ', check_file);
            // console.log('file type: ', check_file?.type);
            // console.log('name: ', check_file.name);
            // console.log('check size --> ', check_file?.size);
            
            // var sizeInMB = (check_file?.size / (1024*1024)).toFixed(2);
            // // setFileSize(check_file?.size); 
            // // setFileSizeInMb(sizeInMB);

            // if (check_file?.size > 512 * 1000 * 1024) {
            //   //if (check_file?.size > 5 * 1000 * 1024) {

            //     document.getElementById("enter-size-title-clicker").title = sizeInMB;
    
            //     //var element = document.getElementById("large-size-popup");
            //     //element.classList.add("active-popup");
            //     //updateShowPopup.current.click();
            //     updateShowPopup.current.click();            
            //     //updateShowPopupChecker.current.click();
    
            //     var elem = document.querySelector('.size-text');
            //     var html = elem.innerHTML;
            //     elem.innerHTML = sizeInMB;
    
            //     console.log('check size__ --> ');
    
            //     setTimeout(function() {
            //         //write.current.click();                
            //         //console.log('with delay --> ');
            //     }, 2000);            
            //     resetUploadedFile();
            //     return false;
            // }
            await createImage(event);

            // Add scrolling to top, especially important for mobile
            // window.scrollTo({ top: 0, left: 0});
            });

        // const handleFileReady = (event) => {
        //     console.log("---- Inside of handleFileReady hook ----");
        //     const { fileBlob } = event.detail;
            
        //     // document.getElementById("imagePreview").src = e.target.result;  // Display preview
        //     // const { fileBlob, poster_info } = event.detail;
        //     // console.log("event.detail: ", event.detail);
        //     // Check if fileBlob and WebViewer instance are available
        //     if (!fileBlob) {
        //     console.error("fileBlob is not defined");
        //     return;
        //     }
        //     if (!instance) {
        //     console.error("WebViewer instance is not initialized.");
        //     return;
        //     }
        //     console.log("--- Inside handleFileReady ---", event.detail);
        //     // await createImage(event);
            
        //     if (fileBlob && instance) {
        //     // In here we set the initial state for the Webviewer

        //     }
        // };

        // window.addEventListener("fileReady", handleFileReady); // Add custom event listener - waiting for file to be uploaded to users browser

 
        // this is a helper function you can use to create a document of whatever height and width you need.
        const createPDF = async (width, height) => {
            const pdfDoc = await instance.Core.PDFNet.PDFDoc.create();
            const pdfPage = await pdfDoc.pageCreate(
                new instance.Core.PDFNet.Rect(0, 0, width, height)
                //new instance.Core.PDFNet.Rect(0, 0, 2000, 2000)
            );
            await pdfDoc.pagePushFront(pdfPage);

            //const pdfPage2 = await pdfDoc.pageCreate(new instance.Core.PDFNet.Rect(0, 0, width, height));
            //await pdfDoc.pagePushFront(pdfPage2);

            const doc = instance.Core.createDocument(pdfDoc);

            //await doc.removePages([2]);
            //doc.pageRemove(2);

            return doc;
        };

        // we use the helper function to create a PDF at a example size of 1000x1000
        if(from_single === 'yes') {
            instance.Core.documentViewer.loadDocument(
                await createPDF(p_w * MULT_NUM, p_h * MULT_NUM)
                
            );
        } else {
            instance.Core.documentViewer.loadDocument(
                await createPDF(docWidth * MULT_NUM, docHeight * MULT_NUM)  
            );
        }

        setWebLoading(false);

        //console.log('then test: ', test);
        if(from_single === 'yes') {

            let get_orig_name = localStorage.getItem("poster-fname-orig");
            let get_orig_name_parts = get_orig_name.split(".");
            let get_orig_name_ext = get_orig_name_parts[get_orig_name_parts.length - 1];

            setIsSingle(true);
            urlImage.current = pres_img_url;
            setProdId(prod_id);
            setSelectedMedia(smedia);
            setPrice(prod_price);
            //setProdImg();
            let get_single_url = localStorage.getItem("poster-furl");
            if(get_orig_name_ext === 'pdf') {
                setInitDoc(get_single_url.replace(".jpg",".pdf"));
                console.log('initDoc ---> ', get_single_url.replace(".jpg",".pdf"));
            } else {
                setInitDoc(get_single_url);
                console.log('initDoc ---> ', get_single_url);
            }
            
            
            console.log('ext ---> ', get_orig_name_ext);
            setFileExt(get_orig_name_ext);
            get_single_url = get_single_url.replace(siteUrl,"");
            //setOrigName(localStorage.getItem("orig-fname").replace(" ","-") + "-" + Date.now());
            setOrigName(localStorage.getItem("poster-fname-orig"));
            console.log('orig name_: ', localStorage.getItem("poster-fname-orig"));

            setIsFullLoading(true);
            // grabs the file that was selected
            let highestWH = 0;
            let type = 'jpg'; //SPHEX CHANGE THIS
            // let timestmp = Date.now();
    
            setFileType(type);
    
            // this is a helper function you can use to create a document of whatever height and width you need.
            let createPDFTemp = async (width, height) => {
                const pdfDoc = await instance.Core.PDFNet.PDFDoc.create();
                const pdfPage = await pdfDoc.pageCreate(
                    new instance.Core.PDFNet.Rect(0, 0, width, height)
                );
                await pdfDoc.pagePushFront(pdfPage);
    
                let temp_type = '';
                if(type === 'tiff')
                    temp_type = 'jpg';
                else
                    temp_type = type;
                
                console.log('create document createPDFTemp');
                const doc = instance.Core.createDocument(pdfDoc, { extension: temp_type, loadAsPDF: true });
    
                return doc;
            };
    
            setDocHeight(p_h);
            setDocWidth(p_w);
    
            if (p_w > p_h) {
                highestWH = p_w;
            } else {
                highestWH = p_h;
            }
    
            instance.Core.documentViewer.loadDocument(
                await createPDFTemp(highestWH * MULT_NUM, highestWH * MULT_NUM)
            );
    
            instance.Core.documentViewer.addEventListener(
                "documentLoaded",
                async () => {
                    //alert('loaded setimage');
    
                    const doc_m = instance.Core.documentViewer.getDocument();
                    await doc_m.insertBlankPages(
                        [1],
                        p_w * MULT_NUM,
                        p_h * MULT_NUM
                    );
                    await doc_m.removePages([2]);
    
                    let doc;
                    let useDataURL = false;
                    let img;
                    let tempOrigHeight = 800;
                    let tempOrigWidth = 800;              
                    
                    // get the first page
                    let pageInfo = doc_m.getPageInfo(1);                
                    
                        console.log("no file.");
    
                        //setCurrFile(file);
                        //uploadImageProduct(file);
                        //uploadImage(file);
                        //await instance.Core.PDFNet.initialize();
                        console.log("after instance");
                        useDataURL = true;
                            
                            // let getFile = '/wp-content/uploads/tmp/brian_king-1693908184445.jpg';

                            img = document.createElement("img");
                            img.src = get_single_url;
    
                            //console.log('base: ', get_base);
        
                            img.onload = function (event) {
                                console.log(event);
                                console.log({ width: img.width, height: img.height });
                                setImgOrigHeight(img.height);
                                setImgOrigWidth(img.width);
                                tempOrigHeight = img.height;
                                tempOrigWidth = img.width;
                            };

                            if(t_w > 0) {
                                setImgOrigHeight(t_h);
                                setImgOrigWidth(t_w);
                                tempOrigHeight = t_h;
                                tempOrigWidth = t_w;
                            }                                
                            
                            //img.src = URL.createObjectURL(getFileUrl);
                            //img.src = URL.createObjectURL(new Blob([fileContent], {type: "image/jpeg'}"}));
                            //img.src = getFileUrl;
                            img.src= get_single_url;
                            
        
                            // check the document type, and create a WebViewer document based on it
                            console.log('annot type: ', type);

                            doc = await instance.Core.createDocument(get_single_url, { extension: type, loadAsPDF: true });

                            
                            //doc = await instance.Core.createDocument(pdfDoc);
                        /* } */
    
                        // check if its wide or tall (width>height)
                        setImgHeight(pageInfo.height);
                        setImgWidth(pageInfo.width);
    
                        if(type === 'tiff') {
                            tempOrigHeight = 4000;
                            tempOrigWidth = 4000;                        
                            setImgOrigHeight(4000);
                            setImgOrigWidth(4000);                        
                        }       
                        
                        console.log('temp orig width: ', tempOrigWidth);
                        console.log('temp orig height: ', tempOrigHeight);
                        console.log('p_w: ', p_w);
                        console.log('p_h: ', p_h);
    
                        let annotWidth = 0;
                        let annotHeight = 0;
                        let checkHeight =
                            (tempOrigHeight / tempOrigWidth) *
                            (p_w * MULT_NUM);
                        let checkWidth =
                            (tempOrigWidth / tempOrigHeight) *
                            (p_h * MULT_NUM);
    
                        checkHeight =
                            (tempOrigHeight / tempOrigWidth) * (p_w * MULT_NUM);
                        let checkHeightWidth = (tempOrigWidth / tempOrigHeight) * checkHeight;                        
    
                        checkWidth =
                        (tempOrigWidth / tempOrigHeight) * (p_h * MULT_NUM);
                        let checkWidthHeight = (tempOrigHeight / tempOrigWidth) * checkWidth;                  
                        console.log("checkWidthHeight: ", checkWidthHeight);
                        
                        instance.Core.Tools.Tool.ALLOW_ANNOTS_OUTSIDE_PAGE = true;

                        console.log('initial ---->');
                        console.log('checkHeight: ', checkHeight);
                        console.log('height: ', p_h);
                        console.log('width: ', p_w);
                        console.log('MULT_NUM: ', MULT_NUM);
                        console.log('p_h * MULT: ', (p_h * MULT_NUM));
                        console.log('checkHeightWidth: ', checkHeightWidth);
                        console.log('p_w * MULT: ', (p_w * MULT_NUM));

                        let f_scale = Math.max((p_w * MULT_NUM) / tempOrigWidth, (p_h * MULT_NUM) / tempOrigHeight);
                        // get the top left position of the image
                        let annotX = ((p_w * MULT_NUM) / 2) - (tempOrigWidth / 2) * f_scale;
                        let annotY = ((p_h * MULT_NUM) / 2) - (tempOrigHeight / 2) * f_scale;
                        
                        annotHeight = tempOrigHeight * f_scale;
                        annotWidth = tempOrigWidth * f_scale;                                  
    
                        const annot = new instance.Core.Annotations.StampAnnotation(
                            {
                                PageNumber: 1,
                                X: annotX,
                                Y: annotY,
                                Width: annotWidth,
                                Height: annotHeight,
                                MaintainAspectRatio: true,
                            }
                        );
                        
                        setPostionXY(
                            annotX,
                            annotY,
                            pageInfo.width,
                            pageInfo.height
                        ); // SetPostion to be upload in server

                        console.log('before load canvas', createPDFTemp);
    
                        // use the load canvas api to generate the image of the loaded doc to be used as the stamp's image.
                        doc.loadCanvas({
                            pageNumber: 1,
                            zoom: 2,
                            drawComplete: async (image) => {
                                console.log('drawcomplete image check: ', image);
                                let data = useDataURL
                                    ? image.toDataURL()
                                    : image.src;
                                setCurrImgData(data);
                                annot.setImageData(data);
                                uploadImageProduct(data);
                                console.log('data check (img): ', data);
                                if(useDataURL) {
                                    console.log('use data url');
                                } else {
                                    console.log('not using data url.');
                                }
    
                                instance.Core.annotationManager.addAnnotation(annot);
                                instance.Core.annotationManager.redrawAnnotation(annot);
                                
                                setWebLoading(false);
                                //setWebviewerLoading(false);
                                setIsFullLoading(false);
    
                            },
                        });
    
                        setHasImage(true);
                        //setIsFullLoading(false);
    
                        setTimeout(() => {
                            //fillImageToDocument();
    
                            const { annotationManager } = instance.Core;
                            const annots = annotationManager
                                .getAnnotationsList()
                                .filter((annot) => annot.PageNumber === 1);
                            annotationManager.selectAnnotations(annots);
    
                        }, 1000);
                        //uploadImage(file); //sphex uncomment on deploy
                        window.scrollTo({ top: 0, left: 0});
                        setLoading(false);
    
                    //}
    
                    instance.Core.documentViewer.removeEventListener();
                }
            );
    
            //return () => instance.Core.documentViewer.removeEventListener('documentLoaded');

            
            }
        });
    }, []);

    useEffect(() => {
        console.log("inside second useEffect: ");
        console.log("height: ", inputHeight);
        console.log("width: ", inputWidth);

        if (inputHeight > inputWidth) {
            console.log("set portrait");
            setLandscapePort(true);
        } else {
            console.log("set landscape");
            setLandscapePort(false);
        }
    }, [inputHeight, inputWidth]);

    // useEffect(() => {
    //     console.log("useEffect mediaInfo", mediaInfo);

    // }, [mediaInfo]);

    useEffect(() => {
        calculateProportionalSize();
    }, [imgOrigWidth, imgOrigHeight]);

    // useEffect(() => {
    //     const toggleLandPortEffect = async () => {
    //         console.log("useEffect toggleLandPort");
    //         // setHasImage(!hasImage);
    //         setDocumentLoading(true);
    //         await sleep(1);
    //         // setHasImage(hasImage);
    //         setDocumentLoading(false);
    //     };
    //     toggleLandPortEffect();
    // }, [landscapePort]);
    // useEffect(() => {
    //     console.log("useEffect proportionalWidth", proportionalWidth);
    //     console.log("useEffect proportionalHeight", proportionalHeight);

    // }, [proportionalWidth, proportionalHeight]);

    const handleOptionChange = (event, position) => {
        setIsMax(false);
        setSelectedSize(event.target.value);
        // let media = mediaListFinal.find((item) => item.id === selectedMedia);
        if (position === "portrait") {
            let portraitObject = portraitList.find(
                (item) => item.val === event.target.value
            );
            setInputWidth(portraitObject.width);
            setInputHeight(portraitObject.height);
            calulatePrice(
                basePrice,
                portraitObject.width,
                portraitObject.height
            );
        } else if (position === "landscape") {
            let landscapeObject = landscapeList.find(
                (item) => item.val === event.target.value
            );
            setInputWidth(landscapeObject.width);
            setInputHeight(landscapeObject.height);
            calulatePrice(
                basePrice,
                landscapeObject.width,
                landscapeObject.height
            );
        }
        if (event.target.value === customeSize.val) {
            setDisableInput(false);
        } else {
            setDisableInput(true);
        }
    };

    // const handleMediaOnchange = (l_id, prod_id) => {
    //     //console.log(event.target.getAttribute('data-prodid'));
    //     //setProdId(event.target.getAttribute('data-prodid'));
    //     setProdId(prod_id);
    //     //setSelectedMedia(event.target.value);
    //     setSelectedMedia(l_id);
    //     //console.log('set selected media --> ', event.target.value);
    //     //let media = listMeida.find((item) => item.id === event.target.value);
    //     let media = mediaListFinal.find((item) => item.id === l_id);

    //     axios.post(`${siteUrl}/wp-content/plugins/ppsposter-react/inc/get_product_price.php`, null, { params: {
    //         get_p_price: 'yes',
    //         get_p_prodid: media.prodid
    //       } } )
    //       .then((response) => {
    //         console.log('check --> ', response );
    //         calulatePrice(parseFloat(response.data), inputWidth, inputHeight);
    //         setBasePrice(parseFloat(response.data));
    //       });        

    //     //calulatePrice(media.val, inputWidth, inputHeight);
    // };

    const calulatePrice = (price, print_width, print_height) => {
        var total_price = Math.ceil(
            (parseFloat(price) * parseFloat(print_width) * parseFloat(print_height)) /
                144.0
        );
        if (total_price * 1 < 20) {
            setPrice(20);
            return;
        }
        setPrice(total_price);
    };

    const setPostionXY = (posX, posY, docWidth, docHeight) => {
        postionXY.current.x = posX;
        postionXY.current.y = posY;
        docSize.current.width = docWidth;
        docSize.current.height = docHeight;
        console.log("-------------------------------------");
        console.log(postionXY);
        console.log(`docHeight ${docHeight}`);
        console.log(`docWidth ${docWidth}`);
        console.log("-------------------------------------");
    };

    // const submitImage = () => {
    //     API.uploadImageStep2(
    //         urlImage,
    //         docSize,
    //         postionXY,
    //         inputWidth,
    //         inputHeight,
    //         price
    //     );
    // };

    const dumpFormData = () => {
        console.log("----- Inside of dumpFormData -----");
        const formData = new FormData(formEl.current);
        const formValues = {};
        formData.forEach((value, key) => {
            formValues[key] = value;
        });
        console.log(JSON.stringify(formValues, null, 2));
    }

    return (
        <div className="outer-container">
            {isErrorModalVisible && (
                
                <div className="error-modal">
                    <div className="modal-overlay">
                        <div className="modal-box">
                            <div className="pps-headline-wrapper">
                                <div className="modal-icon">
                                    <div data-svg-wrapper>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.</svg></svg>w3.org/2000/svg">
                                        <path d="M24.8609 8.77187L19.2281 3.13906C18.8999 2.8117 18.4558 2.62699 17.9922 2.625H10.0078C9.54423 2.62699 9.10013 2.8117 8.77187 3.13906L3.13906 8.77187C2.8117 9.10013 2.62699 9.54423 2.625 10.0078V17.9922C2.62699 18.4558 2.8117 18.8999 3.13906 19.2281L8.77187 24.8609C9.10013 25.1883 9.54423 25.373 10.0078 25.375H17.9922C18.4558 25.373 18.8999 25.1883 19.2281 24.8609L24.8609 19.2281C25.1883 18.8999 25.373 18.4558 25.375 17.9922V10.0078C25.373 9.54423 25.1883 9.10013 24.8609 8.77187ZM13.125 8.75C13.125 8.51794 13.2172 8.29538 13.3813 8.13128C13.5454 7.96719 13.7679 7.875 14 7.875C14.2321 7.875 14.4546 7.96719 14.6187 8.13128C14.7828 8.29538 14.875 8.51794 14.875 8.75V14.875C14.875 15.1071 14.7828 15.3296 14.6187 15.4937C14.4546 15.6578 14.2321 15.75 14 15.75C13.7679 15.75 13.5454 15.6578 13.3813 15.4937C13.2172 15.3296 13.125 15.1071 13.125 14.875V8.75ZM14 20.125C13.7404 20.125 13.4867 20.048 13.2708 19.9038C13.055 19.7596 12.8867 19.5546 12.7874 19.3148C12.6881 19.0749 12.6621 18.811 12.7127 18.5564C12.7634 18.3018 12.8884 18.068 13.0719 17.8844C13.2555 17.7009 13.4893 17.5759 13.7439 17.5252C13.9985 17.4746 14.2624 17.5006 14.5023 17.5999C14.7421 17.6992 14.9471 17.8675 15.0913 18.0833C15.2355 18.2992 15.3125 18.5529 15.3125 18.8125C15.3125 19.1606 15.1742 19.4944 14.9281 19.7406C14.6819 19.9867 14.3481 20.125 14 20.125Z" fill="#D41026"/>
                                        </svg>
                                    </div>
                                </div>

                                <h2 className="modal-title">{errorMessages[errorType]?.headline}</h2>
                            </div>
                            <p className="modal-text">
                                {errorMessages[errorType]?.body_text}
                            </p>
                            {errorMessages[errorType]?.bullet_text && (
                            <ul className="modal-list">
                                <li>{errorMessages[errorType]?.bullet_text}</li>
                            </ul>
                            )}
                            <div className="modal-warning">
                            <span className="warning-icon">️
                                <div data-svg-wrapper >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.375 8.12503V11.25C9.375 11.5952 9.65482 11.875 10 11.875C10.3452 11.875 10.625 11.5952 10.625 11.25V8.12503C10.625 7.77985 10.3452 7.50003 10 7.50003C9.65482 7.50003 9.375 7.77985 9.375 8.12503Z" fill="#FFC906"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.381 2.81193C8.381 2.81193 8.63025 2.37797 9.06335 2.12682C9.06335 2.12682 9.4978 1.87488 10 1.87488C10 1.87488 10.5022 1.87488 10.9367 2.12682C10.9367 2.12682 11.3712 2.37875 11.6206 2.81464L18.494 14.6869C18.494 14.6869 18.7452 15.1219 18.7456 15.6234C18.7456 15.6234 18.7461 16.1249 18.4961 16.5597C18.4961 16.5597 18.2461 16.9945 17.8124 17.2464C17.8124 17.2464 17.3787 17.4983 16.8772 17.5001L3.12502 17.5001C3.12502 17.5001 2.6213 17.4983 2.18764 17.2464C2.18764 17.2464 1.75397 16.9945 1.50398 16.5597C1.50398 16.5597 1.25398 16.1249 1.25443 15.6234C1.25443 15.6234 1.25487 15.1219 1.50564 14.6876L8.37944 2.81464L8.381 2.81193ZM2.58816 15.3126L9.4627 3.43837L9.4643 3.43559L9.46465 3.43498C9.46465 3.43498 9.54707 3.29128 9.69041 3.20815C9.69041 3.20815 9.83402 3.12488 10 3.12488C10 3.12488 10.166 3.12488 10.3096 3.20815C10.3096 3.20815 10.4532 3.29143 10.5357 3.43551L17.4123 15.3132C17.4123 15.3132 17.4955 15.4574 17.4956 15.6245C17.4956 15.6245 17.4958 15.7917 17.4124 15.9366C17.4124 15.9366 17.3291 16.0816 17.1845 16.1655C17.1845 16.1655 17.04 16.2495 16.8728 16.2501L3.12502 16.2501C3.12502 16.2501 2.96005 16.2495 2.8155 16.1655C2.8155 16.1655 2.67094 16.0816 2.58761 15.9366C2.58761 15.9366 2.50428 15.7917 2.50443 15.6245C2.50443 15.6245 2.50457 15.4574 2.58816 15.3126Z" fill="#FFC906"/>
                                        <path d="M10.9375 14.0625C10.9375 14.5803 10.5177 15 10 15C9.48227 15 9.0625 14.5803 9.0625 14.0625C9.0625 13.5448 9.48227 13.125 10 13.125C10.5177 13.125 10.9375 13.5448 10.9375 14.0625Z" fill="#FFC906"/>
                                    </svg>
                                </div>
                            </span>
                            <p>
                                {errorMessages[errorType]?.warning_text}
                            </p>
                            </div>
                            {errorMessages[errorType]?.button_type == "goback" && (
                                <button className="modal-button" onClick={() => window.location.reload(true) }>Go back</button>
                            )}

                            {errorMessages[errorType]?.button_type == "continue" && (
                                // <button className="modal-button" onClick={() => setIsErrorModalVisible(false)}>Continue</button>
                                <button className="ppsow-button button2 button-orange button-continue button-center" onClick={() => { setIsErrorModalVisible(false); generatePDF(); }} >
                                        <span className="text">Continue</span>
                                        {/* <img className="uploadsimple-r-icon" alt="" src={`${mediaUrl}/ArrowRightWhite.svg`} /> */}
                                </button>
                            )}

                            {errorMessages[errorType]?.button_type == "retryoradvanced" && (
                                <div className="retry-advanced-wrapper">
                                    {/* <button className="modal-button" onClick={() => setIsErrorModalVisible(false)}>Go back</button> */}
                                    <div className="modal-button-group">
                                        <button className="modal-button secondary button-light retry-button" onClick={() => window.location.reload(true) }>Try again</button>
                                        <button className="modal-button primary retry-button" onClick={() => window.location.href = '/advanced-order/'}>Advanced Order</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <div 
                style={{ display: hasImage ? "none" : "none" }}
                className="step1 container"
            >
                {
                        <div
                            style={{ display: 'none' }}
                            className="hide upload-content poster_uplaod_button_pdf"
                            onClick={() => fileInputRef.current.click()}
                        >
                            <label>
                                <img alt="" src={upload} />
                                <div>Upload</div>
                            </label>
                            <input
                                className="uploadBtn"
                                ref={fileInputRef}
                                onChange={async (e) => {
                                    await createImage(e);
                                }}
                                disabled={isMax}
                                id="file-picker"
                                type="file"
                                accept=".pdf,.jpg,.jpeg,.png,.tiff,.tif"
                            ></input>

                        </div>
                }


            </div>

            <div className="mainContainer mainContainerV2">
                { isFullLoading &&
                <div className="wiz-full-loader-cont">
                    <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    <div className="loader-text">{isTiff && loadingTiff && !isSingle ? 'Uploading & Processing TIFF - Please Be Patient…' : ''}</div>
                </div>
                }
                {isDevelopment && <input style={{ display: 'none' }} type='file' id='file-picker' accept='image/*,application/pdf' />}
                <div className={`inner-main-wrapper ${hasImage ? "showme" : "hideme"}`} >
                    <div className="main-main-wrapper">
                        <div className="ppsow-breadcrumb">
                            <div className="home-parent">
                                <img className="home-icon" alt="" src={`${mediaUrl}/home.svg`} />
                                
                                <div className="link">
                                    <div className="ppsow-title"><a href="/">Home</a></div>
                                </div>
                            </div>
                            <img className="home-icon" alt="" src={`${mediaUrl}/chevron-right.svg`} />
                            {categoryUrl &&  
                                <>
                                    <div className="link">
                                        <div className="ppsow-title"><a href={categoryUrl} >{categoryName}</a></div>
                                    </div>
                                    <img className="home-icon" alt="" src={`${mediaUrl}/chevron-right.svg`} />
                                </>
                            } 
                            <div className="link">
                                <div className="ppsow-title"><a href={productUrl} >{productName}</a></div>
                            </div>
                            <img className="home-icon" alt="" src={`${mediaUrl}/chevron-right.svg`} />
                            
                            <div className="link2">
                                <div className="width">Print layout & preview</div> 
                            </div>
                        </div>
                        <div className="main-wrapper">

                            <div className={`viewerPhoto stampViewerPhoto `}>
                        
                                <div className="containBox">
                                    <div className="left-column column editImage"> 
                                        <div className={`mobileOverlay ${!mobileLock ? "hideLock" : "showLock"} `}></div>
                                        {webviewerLoading && 
                                            <img src={`${siteUrl}/wp-content/themes/pps/images/ajax-loader-image.gif`} className="viewerLoading" />
                                        }
                                        {/* <div id="viewer" style={{ pointerEvents: /* documentLoading && 'none' }} ref={viewer} className="webView webViewV2" ></div> */}
                                        <div id="viewer" style={{ pointerEvents: documentLoading && 'none' }} ref={viewer} className="webView webViewV2" ></div>
                                        {/* <img className="desktop-2-child" alt="" src="https://pps.local/wp-content/uploads/logantestimage.webp?time=1733654974" /> */}
                                        <a href='#link-popup' title="300" ref={updateShowPopup} id="enter-size-title-clicker" style={{display: 'none'}}></a>
                                        <h3 ref={updateShowPopupChecker} id="enter-size-title-clicker-check" style={{display: 'none'}}>Order Wizard</h3>
                                        <div className={`mobileOverlay ${!mobileLock ? "hideLock" : "showLock"} `}></div>
                                        {/* <div id="viewer" style={{ pointerEvents: documentLoading && 'none' }} ref={viewer} className="webView webViewV2" ></div> */}
                                        {/* <img className="desktop-2-child" alt="" src="https://pps.local/wp-content/uploads/logantestimage.webp?time=1733654974" /> */}
                                        <div className={`progressbar-wrapper ${loading ? "isUploading" : "isNotUploading"}`}>
                                            {/* {documentLoading && <div className="spinner"></div>} */}
                                            { loading &&  <ProgressBar bgcolor={"#ec6702"} completed={completed} /> }
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="right-column column input-field-parent">
                                <div className="inner-wrapper white-bg">
                                <div className="ppsow-explanation-text-wrapper file-input-row input-field">
                                    <div className="ppsow-explanation-text-inner-wrapper input">
                                        <div className="ppsow-explanation-text width">We’ve placed your uploaded image on your requested print size. 
                                        You can drag or resize it as needed to fit. Use the toggles below to further control your layout.</div> 
                                    </div>
                                </div>
                                <div className="file-input-row input-field">
                                    <div className="ppsow-title-parent">
                                        {/* Debugging: Click on File to generate Thumbnail */}
                                        <div className="ppsow-title">File</div>
                                        <div className="ppsow-title-group">
                                            <div className="ppsow-title tooltip-blue tooltip-help your-print-size-tooltip">Help</div>
                                            {/* <img className="info-r-icon" alt="" src={`${mediaUrl}/Info-r.svg`} /> */}
                                            <div className="notice">
                                                <div className="tooltip-container help-tooltip">
                                                    <span className="tooltip-trigger">
                                                        <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                    </span>
                                                    <div className="tooltip-content-react">
                                                        <div className="tooltip-title">Help</div>
                                                        <p className="tooltip-description">{ isExactMatch ? description.help2 : description.help1 }</p>
                                                        {/* Tooltip content all the text we want to have will be here */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ppsow-file-row input">
                                        <div className="ppsow-filename width">{origFName}</div> 
                                        <div className="content">
                                        </div>
                                    </div>
                                </div>
                                <div className="crop-tool-lock input-column input-column2 input-field3 item-name show-mobile-only">
                                    <div className="ppsow-title-wrapper ppsow-title-container">
                                        <div className="ppsow-title">Viewer Lock</div>
                                        <div className="notice">
                                            <div className="crop-tool-tooltip tooltip-container">
                                                <span className="tooltip-trigger">
                                                    <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                </span>
                                                <div className="tooltip-content-react">
                                                    <div className="tooltip-title">Help</div>
                                                    <p className="tooltip-description">{description.viewer_lock}</p>
                                                    {/* Tooltip content all the text we want to have will be here */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="print-dimension-wrapper portrait-parent">
                                        <div className="width">Unlock</div>
                                        <div className="ppsow-toggle-switch-wrapper elementor-widget-container">
                                            <input 
                                            type="checkbox" 
                                            id="toggleMobileSwitch" 
                                            checked={mobileLock} 
                                            onClick={toggleMobileLock}
                                            />
                                            <label className='ppsow-label' for="toggleMobileSwitch">Toggle</label>
                                        </div>
                                        <div className="width">Lock</div>
                                    </div>
                                </div>
                                <div className="ppsow-print-media-row input-field">
                                    <div className="ppsow-print-media-title ppsow-title ppsow-title3">Print Media</div>
                                    <div className="input1">
                                        <div className="content1">
                                            <div className="ppsow-print-media ppsow-title5" style={{ color: "#6b7280" }}>{mediaName}</div>
                                            {/* <div className="ppsow-title5">Option 1</div> */}
                                            <img className="chevron-down-icon" alt="" src={`${mediaUrl}/chevron-down.svg`} />
                                            
                                        </div>
                                    </div>
                                    </div>
                                    <div className="ppsow-print-size-row input-field-wrapper input-field-group">
                                        <div className="ppsow-print-size-column input-column input-column1 input-field2">
                                            <div className="ppsow-title-container">
                                                <div /*onClick={dumpFormData}*/ className="ppsow-print-title ppsow-title">Your print size</div>
                                                {/* <img className="info-r-icon" alt="" src={`${mediaUrl}/Info-r.svg`} /> */}
                                                <div className="notice">
                                                    <div className="tooltip-container your-print-size-tooltip">
                                                        <span className="tooltip-trigger">
                                                            <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                        </span>
                                                        <div className="tooltip-content-react">
                                                            <div className="tooltip-title">Print Size</div>
                                                            <p className="tooltip-description">{description.print_size}</p>
                                                            {/* Tooltip content all the text we want to have will be here */}
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div className="input print-dimension-wrapper ">
                                                <div className="ppsow-input input2 print-dimension print-width">
                                                    <div className="content2">
                                                    <div className="ppsow-title3">{inputWidth}<span className="ppsow-inches-sign">"</span></div> { /* This doesn't yet work, the state is not set...  */}
                                                    {/* <div className="ppsow-title3">24</div> */}
                                                    </div>
                                                </div>
                                                <div className="width">Width</div>
                                                <div className="x">x</div>
                                                <div className="ppsow-input input2 print-dimension print-height">
                                                    <div className="content2">
                                                    <div className="ppsow-title3 print-dimension print-height">{inputHeight}<span className="ppsow-inches-sign">"</span></div> { /* This doesn't yet work, the state is not set...  */}
                                                    </div>
                                                </div>
                                                <div className="width">Height</div>
                                            </div>
                                        </div>
                                        {/* {!isCropApplied && (  */}
                                        <div className="ppsow-orientation-div ppsow-orientation-wrapper input-column input-column2 input-field3">
                                            <div className="ppsow-title-container ppsow-title-wrapper">
                                                <div className="ppsow-title">Orientation</div>
                                                <div className="notice ppsow-notice">
                                                    <div className="orientation-tooltip-container tooltip-container your-print-size-tooltip">
                                                        <span className="tooltip-trigger">
                                                            <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                        </span>
                                                        <div className="tooltip-content-react">
                                                            <div className="tooltip-title">Orientation</div>
                                                            <p className="tooltip-description">{description.orientation}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="print-dimension-wrapper portrait-parent">
                                                <div className="width">Portrait</div>
                                                <div className="ppsow-toggle-switch-wrapper elementor-widget-container">
                                                    <input 
                                                    type="checkbox" 
                                                    id="orientationSwitch" 
                                                    checked={isLandscape} 
                                                    //   onClick={togglePortraitLandscape}
                                                    />
                                                    
                                                    <label className='ppsow-label' for="orientationSwitch">Toggle</label>
                                                </div>
                                                <div className="width">Landscape</div>
                                            </div> */}
                                            <div className="ppsow-orientation-toggle ppsow-toggle-outer print-dimension-wrapper portrait-parent">
                                                <div className="width">Landscape</div>
                                                <div className="ppsow-toggle-switch-wrapper elementor-widget-container">
                                                    <input 
                                                    type="checkbox" 
                                                    id="landPortSwitch" 
                                                    checked={landscapePort} 
                                                    onClick={toggleLandPort}
                                                    />
                                                    
                                                    <label className="ppsow-label" for="landPortSwitch">Toggle</label>
                                                </div>
                                                <div className="width">Portrait</div>
                                            </div>
                                        </div>
                                        {/* )} */}
                                    </div>
                                    <div className="ppsow-scale-aspect-row ppsow-toggle-row input-field-wrapper input-field-group">
                                        <div className="ppsow-toggle-container input-column input-column1 input-field2">
                                            <div className="ppsow-image-scale-to ppsow-toggle-inner-container ppsow-title-container">
                                                <span className="title-toggle-wrapper">
                                                <div onClick={calculateProportionalSize} className="ppsow-title">Image scale to </div>
                                                <div className="notice ppsow-notice">
                                                    <div className="tooltip-container your-print-size-tooltip">
                                                        <span className="tooltip-trigger">
                                                            <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                        </span>
                                                        <div className="tooltip-content-react">
                                                            <div className="tooltip-title">Image Scale to</div>
                                                            <p className="tooltip-description">{description.image_scale_to}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                </span>
                                                <div className="ppsow-toggle-outer print-dimension-wrapper portrait-parent">
                                                    <div className="width">Fit</div>
                                                    <div className="ppsow-toggle-switch-wrapper elementor-widget-container">
                                                        <input 
                                                        type="checkbox" 
                                                        id="fitFillSwitch" 
                                                        checked={fitFill} 
                                                        onClick={toggleFitFill}
                                                        />
                                                        
                                                        <label className="ppsow-label" for="fitFillSwitch">Toggle</label>
                                                    </div>
                                                    <div className="width">Fill</div>
                                                </div>
                                            </div>
                                            <div className="ppsow-aspect-ratio ppsow-toggle-inner-container ppsow-title-container">
                                                <span className="title-toggle-wrapper">
                                                <div /*onClick={dumpFormData}*/ className="ppsow-title">Aspect ratio</div>
                                                <div className="notice ppsow-notice">
                                                    <div className="tooltip-container your-print-size-tooltip">
                                                        <span className="tooltip-trigger">
                                                            <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                        </span>
                                                        <div className="tooltip-content-react">
                                                            <div className="tooltip-title">Aspect ratio</div>
                                                            <p className="tooltip-description">{description.aspect_ration}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                </span>
                                                <div className="ppsow-toggle-outer print-dimension-wrapper portrait-parent">
                                                    <div className="width">Lock</div>
                                                    <div className="ppsow-toggle-switch-wrapper elementor-widget-container">
                                                        <input 
                                                        type="checkbox" 
                                                        id="aspectLockSwitch" 
                                                        checked={aspectLock} 
                                                        onClick={toggleAspectLock}
                                                        />
                                                        
                                                        <label className="ppsow-label" for="aspectLockSwitch">Toggle</label>
                                                    </div>
                                                    <div className="width">Unlock</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {!isExactMatch && (
                                    <div className="ppsow-print-size-match-row ppsow-toggle-row input-field-wrapper input-field-group">
                                        <div className="ppsow-toggle-container input-column input-field2">
                                            <div className="ppsow-toggle-inner-container ppsow-title-container">
                                            {/* {!isExactMatch && ( */}
                                                <span className="title-toggle-wrapper">
                                                    <div onClick={dumpFormData} className="ppsow-title">Change print size to match image size?</div>
                                                    <div className="notice ppsow-notice">
                                                        <div className="tooltip-container your-print-size-tooltip">
                                                            <span className="tooltip-trigger">
                                                                <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                            </span>
                                                            <div className="tooltip-content-react">
                                                                <div className="tooltip-title">Size to fit image</div>
                                                                <p className="tooltip-description">{description.size_to_fit_image}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                            {/* )}  */}
                                                <div className="ppsow-size-to-fit-text-wrapper file-input-row input-field">
                                                    <div className="ppsow-size-to-fit-text-inner-wrapper input">
                                                        <div className="ppsow-size-to-fit-text width">
                                                            Your image sizes proportionally to {proportionalWidth} x {proportionalHeight}. 
                                                            If you don’t want to crop your image, 
                                                            you can change your print size to match your image size.
                                                        </div> 
                                                    </div>
                                                </div>
                                                <div className="ppsow-change-print-size ppsow-toggle-outer print-dimension-wrapper portrait-parent">
                                                    <div className="width">Requested Print Size</div>
                                                    <div className="ppsow-toggle-switch-wrapper elementor-widget-container">
                                                        <input 
                                                        type="checkbox" 
                                                        id="printFitSwitch" 
                                                        checked={printFitSize} 
                                                        onClick={togglePrintFitSize}
                                                        />
                                                        
                                                        <label className="ppsow-label" for="printFitSwitch">Toggle</label>
                                                    </div>
                                                    <div className="width">Size To Fit<span className="hideontiny"> Image</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     )} 
                                    {/* <div className="ppsow-help-text-blue ppsow-why-white-space ppsow-title-group">
                                        <div className="ppsow-title tooltip-blue tooltip-help your-print-size-tooltip">Why Do I See White Space?</div>
                                        <div className="notice ppsow-notice">
                                            <div className="tooltip-container help-tooltip">
                                                <span className="tooltip-trigger">
                                                    <img alt="" src={`${mediaUrl}/Info-r.svg`} />
                                                </span>
                                                <div className="tooltip-content-react">
                                                    <div className="tooltip-title">Why Do I See White Space?</div>
                                                    <p className="tooltip-description">{ description.white_space}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                
                                    {/* {isCropApplied && ( */}
                                    <div className="ppsow-button-parent button-parent webv-step webv-step2">
                                    {/* <div 
                                        id="change-file"
                                        className="ppsow-button button-light button-change-file"
                                        onClick={startOver()}
                                    >
                                        <img className="uploadsimple-r-icon" alt="" src={`${mediaUrl}/UploadSimple-r.svg`} />
                                        <div className="text">Change File</div>
                                    </div> */}
                                    <div 
                                        id="order-wizard-go-back"
                                        className="ppsow-button button1 button-light"
                                        onClick={() => {
                                            startOver();
                                        }}
                                    >
                                        <img className="ArrowRightOrange-icon" alt="" src={`${mediaUrl}/ArrowLeftOrange.svg`} />                        
                                        <div className="text4">Start Over</div>
                                    </div>
                                    
                                    {/* <button //turn div into button so that disabled will work 
                                        id="order-wizard-download-proof"
                                        className="ppsow-button button-light button-download"
                                        // onClick={downloadProof}
                                        disabled={isDownloadingProof}
                                    >
                                        {isDownloadingProof ? (
                                        <>
                                            <div className="text">Downloading... <span className="loading-circle1"></span></div>
                                        </>
                                        ) : (
                                        <>
                                            <img className="uploadsimple-r-icon" alt="" src={`${mediaUrl}/DownloadSimple-r.svg`} />
                                            <div className="text">Download Proof</div>
                                        </>
                                        )} { /*!loading && <FontAwesomeIcon icon={faArrowRight} className="accept-icon" />*/}
                                    { /* </button> */}
                                    <button
                                        id="order-wizard-download-proof"
                                        className="ppsow-button button-light button-download"
                                        onClick={dumpInfoToConsole}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div className="text"><span className="loading-circle1"></span></div>
                                            // <div className="loading-circle"></div>
                                        ) : (
                                            <>
                                            <img className="uploadsimple-r-icon" alt="" src={`${mediaUrl}/DownloadSimple-r.svg`} />
                                            <div className="text">Download Proof</div>
                                            {/* <div>Download Proof <FontAwesomeIcon icon={faArrowCircleDown} className="download-proof-icon" /></div> */}
                                            </>
                                            
                                        )}
                                    </button>
                                    {/* <button
                                        className="dlProof"
                                        onClick={dumpInfoToConsole}
                                        disabled={loadingDownload}
                                    >
                                        {loadingDownload ? (
                                            <div className="loading-circle"></div>
                                        ) : (
                                            <div>Download Proof <FontAwesomeIcon icon={faArrowCircleDown} className="download-proof-icon" /></div>
                                            
                                        )}
                                    </button> */}
                                    
                                    {/* <button
                                        className="acceptCont"
                                        onClick={generatePDF}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <span>{genPdf ? 'Processing...' : 'Uploading File...'} <span className="loading-circle1"></span></span>
                                        ) : (
                                            "Accept & Continue"
                                        )} {!loading && <FontAwesomeIcon icon={faArrowRight} className="accept-icon" />}
                                    </button> */}
                                    <button //turn div into button so that disabled will work 
                                    id="order-wizard-continue" // Add conditional for product pages later on this id, for MixPanel tracking
                                    className="acceptCont ppsow-button button2 button-orange button-continue"
                                    onClick={generatePDF}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="text">{genPdf ? 'Processing...' : 'Uploading...'} <span className="loading-circle1"></span></span>
                                        </>
                                    ) : (
                                        <>
                                        <span className="text">Continue</span>
                                        <img className="uploadsimple-r-icon" alt="" src={`${mediaUrl}/ArrowRightWhite.svg`} />
                                        </>
                                    )} { /*!loading && <FontAwesomeIcon icon={faArrowRight} className="accept-icon" />*/}
                                    </button>
                                    </div>
                                    {/* )} */}
                                    <form style={{display: 'none'}} method="POST" ref={formEl} action={`${siteUrl}/order-configure-s/`}>
                                        <input type="text" ref={formFName} name="fname" value={fname} />
                                        <input type="hidden" ref={formOrgSrc} name="org_src" value="" />
                                        <input type="text" name="m_type" value="photo-gloss" />
                                        <input type="text" name="product_id" value={prodId} />
                                        <input type="text" name="p_w" value={inputWidth} />
                                        <input type="text" name="p_h" value={inputHeight} />
                                        <input type="text" name="pdftron" value="1" />
                                        <input type="text" name="fileExt" value={fileExt} />
                                        <input type="hidden" name="orig_name" value={origName} />
                                        <input type="hidden" name="original_filename" value={origFName} />
                                        <input type="text" name="image_origheight" value={imgOrigHeight} />
                                        <input type="text" name="image_origwidth" value={imgOrigWidth} />
                                        <input type="text" name="image_thumb" value="up" />
                                        <input type="hidden" name="type" value={fType} />
                                        <input type="text" name="fileNamenoEXT" value={fileNameNoExt} />
                                        <input type="hidden" name="image_quality" value="ok" />
                                        <input type="text" name="initdoc" value={initDoc} />
                                        <input type="text" name="initdocR" value={orderMethod} />
                                        <input type="hidden" name="reactPoster" value={orderMethod} />
                                        <input type="hidden" name="orderMethod" value={orderMethod} />
                                        <input type="hidden" name="time_s" value={jsTime} />
                                        <input type="text" name="productName" value={productName} />
                                        <input type="text" name="productUrl" value={productUrl} />
                                        <input type="text" name="categoryName" value={categoryName} />
                                        <input type="text" name="categoryUrl" value={categoryUrl} />
                                        <input type="submit" value="Submit" style={{display: 'none'}} />
                                    </form>

                                    
                                </div>
                            </div>
            
                        </div>
                    </div>
                </div>
            
        
                {/* <Frontend {...stateAndRefs} />  /* Old templates inside frontend.jsx */} 
            </div>
      </div>
    );
}

export default App;
